// Rules content extracted verbatim from the reference site (tenexch.com) rules modal.
// Structure: sport -> categories -> rules ({ text, danger }).
const rulesData = [
  {
    "name": "Football",
    "categories": [
      {
        "name": "bookmaker",
        "rules": [
          {
            "text": "If the match will not take place within 48 hours of the original kick-off time bets will be void.",
            "danger": false
          },
          {
            "text": "If the selection is in a multiple bet or accumulator any refund must be requested before kick-off of the first leg of the multiple bet.",
            "danger": true
          },
          {
            "text": "Where a confirmed postponed match features as part of a multiple bet, the bet will stand on the remaining selections in the multiple.",
            "danger": true
          },
          {
            "text": "Please note that games which have their kick-off altered well in advance to accommodate live TV, or to ease fixture congestion will not be classed as postponed.",
            "danger": false
          },
          {
            "text": "If a match is forfeited or a team is given a walkover victory without the match having kicked off, then all bets will be void. Any subsequently awarded scoreline will not count for settlement purposes.",
            "danger": true
          }
        ]
      },
      {
        "name": "match",
        "rules": [
          {
            "text": "Match Odds :- All bets apply to the relevant full 'regular time' period including stoppage time. Any extra-time and/or penalty shoot-out is not included. For the cancellation of a goal, due to VAR, bets matched between the time of the goal being scored and the time at which the video assistant referee finishes the review will be voided. For the cancellation of a red card, due to VAR, bets matched after the time at which the video assistant referee commences the review will be voided.",
            "danger": false
          },
          {
            "text": "Under_Over Goals :- In the event of a match starting but not being completed, all bets will be void, unless the specific market outcome is already determined,",
            "danger": false
          },
          {
            "text": "1st Period Winner :- Bets will be void if the match is abandoned before half-time.",
            "danger": false
          },
          {
            "text": "Next Goal :- Own goals count to the side credited with the goal.",
            "danger": false
          },
          {
            "text": "Draw No Bet :- Predict which team will be the winner. In case of a draw, all bets will be void. If a game is abandoned, bets will be void.",
            "danger": false
          },
          {
            "text": "Both Teams to Score :- Predict whether both teams will score at least one goal in the game. Own goals count towards the team credited with the goal. If a game is abandoned, bets will be void, unless the outcome of these bets is already determined. Yes” – meaning that both teams will score. “No” – meaning that either team will not score.",
            "danger": false
          },
          {
            "text": "Total Corners :- Predict which team will take the named corner in the game. If this specific corner is not taken in the game, bets will be void. For example, game finishes or is abandoned with 8 corners taken – all bets on any corner after the 8th will be void (9th, 10th, etc.).",
            "danger": false
          },
          {
            "text": "Goals Odd/Even :- Any match resulting in 0-0 will be settled on an even number of goals. For Team Odd/Even markets, if the specified team does not score then we will settle on an even number of goals. In the event of an abandoned match then bets for that match will be void.",
            "danger": false
          },
          {
            "text": "1X2 Corners :- Predict which team will get more corners in a match. Awarded, but not taken corners (there is a corner, but before it is taken the referee signals for the end of the first half or the match) will not count for settlement purposes. Also if a corner needs to be re-taken for any reason, it will be counted as 1 corner.",
            "danger": false
          },
          {
            "text": "Under/Over Card in Match (Number of cards) :- Predict the number of the cards which will be shown in a match. If a player is sent off for 2 yellow cards, this counts as 2 yellow cards and 1 red card for betting purpose es. If the match is abandoned for any reason, all bets will be void unless market is already determined, e.g. Team 1 over 2,5 yellow cards - 3 yellow cards awarded to Team 1 before abandonment is settled as a winner. Cards for non-players (already substituted players, managers, players on bench which are not substituted in) are not considered. Settlement will be made with reference to all available evidence to cards shown during the scheduled 90 minutes play. Any card shown after the full-time whistle blow will be disregarded.",
            "danger": false
          },
          {
            "text": "First Half Under/Over Goals :- How many goals will be scored in this first half of this match? All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.",
            "danger": false
          },
          {
            "text": "Penalty Taken? :- Will a penalty be awarded and taken during this match? All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.",
            "danger": false
          },
          {
            "text": "Correct Score :- Predict the score of this match. This market will not be partially settled during the fixture and will be fully settled at full time. All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.",
            "danger": false
          },
          {
            "text": "Corners Number/Odds : - How many corners will be taken in the match? Only corners that are taken will be counted. All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.",
            "danger": false
          },
          {
            "text": "Team_A/B +1/2/3 : - Who will win this match with the stated handicap applied? All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.",
            "danger": false
          },
          {
            "text": "HT/FT :- Bets will be void if the match is abandoned. Extra-time and penalty shootouts do not count.",
            "danger": false
          },
          {
            "text": "The company reserves the right to suspend or void any ID/bets found to be illegitimate, including cases involving VPN usage, bots/robot use, multiple entries from the same or different IP addresses, exploitation or manipulation of odds in any market, and similar activities. Note: Only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          },
          {
            "text": "“In the event of a technical error or any unforeseen circumstance that leads to the suspension of the Provider’s side of any market (Match_Odds,Over/Under, etc.) during a sporting event, and the market does not resume, the outcome will be settled based on the current result (win/loss) at the time of suspension. All bets placed prior to suspension will remain valid and will be settled accordingly. The company assumes no responsibility or liability for such interruptions or outcomes.”",
            "danger": true
          }
        ]
      },
      {
        "name": "fancy",
        "rules": [
          {
            "text": "(1) Tournament Total Goals :- For markets applying to the whole tournament, goals scored in 90 minutes or in extra-time will count. Goals scored in penalty shootouts do not count.",
            "danger": false
          },
          {
            "text": "(2) Player Tournament Total Goals :- Player must take some part in the tournament for bets to stand. Goals in 90 minutes and extra-time count. Goals scored in penalty shootouts do not count.",
            "danger": false
          },
          {
            "text": "(3) Tournament Total Headed Goals :- For markets applying to the whole tournament, goals scored in 90 minutes or in extra-time will count.",
            "danger": false
          },
          {
            "text": "(4) Tournament Total Own Goals :- For markets applying to the whole tournament, Own goals scored in 90 minutes or in extra-time will count.",
            "danger": false
          },
          {
            "text": "(5) Tournament Total Corners :- Only corners taken in 90 minutes count.",
            "danger": false
          },
          {
            "text": "(6) Tournament Total Yellow / Red Cards :- The maximum number of cards per player per match is one yellow and one red (e.g. a second yellow card leading to a red card does not count). Cards awarded in extra-time do not count. Only players on the pitch count (e.g., if a manager or a substitute on the bench is shown a card, it will not count for these markets).",
            "danger": false
          },
          {
            "text": "(7) Tournament Total Converted / Missed Penalties :- Penalties taken in 90 minutes, extra-time and penalty shootouts all count. If a penalty has to be re-taken the previous disallowed penalty(ies) do not count.",
            "danger": false
          },
          {
            "text": "(8) Tournament Total Matches with Extra Time :- Matches that go beyond 90 minutes into extra time count. Matches decided in extra time or by penalty shootout are included.",
            "danger": false
          },
          {
            "text": "(9) Tournament Total Penalty Shootouts :- Matches decided by penalty shootout count. Only official FIFA-recognised penalty shootouts are included.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Horse Racing",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "1.General",
            "danger": true
          },
          {
            "text": "All individual race markets will be determined according to the official result at the time of the 'weigh-in' announcement (or equivalent). Subsequent disqualifications, appeals or amendments to the result will be disregarded.",
            "danger": false
          },
          {
            "text": "If a race is abandoned or otherwise declared void, or in the event of a walkover, all bets on that race will be void.",
            "danger": false
          },
          {
            "text": "If the scheduled venue is changed after the market has been loaded by us, all bets will be void.",
            "danger": false
          },
          {
            "text": "Where a race does not take part on its scheduled day, all bets will be void.",
            "danger": false
          },
          {
            "text": "If a scheduled surface type is changed (e.g. turf to dirt) all bets will stand.",
            "danger": false
          },
          {
            "text": "2.Non-Runner Rule",
            "danger": true
          },
          {
            "text": "Our's non-runner rule relates to the adjustment of odds on bets already matched when a horse in a race is declared a non-runner. In order to make the adjustment We applies a reduction factor to the remaining runners. The reduction factor allocated to a non-runner is a calculation (the details of which are described below) of that horse's chances of winning (or being placed, etc as appropriate) and is applied to bets already matched on the other runners in the relevant market or markets.",
            "danger": false
          },
          {
            "text": "Any horse listed when the relevant market is loaded which does not subsequently come under starter's orders is deemed to be a non-runner.",
            "danger": false
          },
          {
            "text": "When the market is loaded each horse is given a 'reduction factor', based on a forecast price, which is expressed as a percentage. These reduction factors may be updated periodically at the discretion of Us based on trading in the market, but after approximately 15 minutes (approximately 5 minutes for Australian and US markets) from the scheduled 'off' time of a given race, they will be updated only in exceptional circumstances. The current reduction factor percentage for each horse can be viewed on the 'info' page on Our website or by asking the Helpdesk.",
            "danger": false
          },
          {
            "text": "Accurate reduction factors will only be applied to selections in the event of a non-runner. Once a non-runner is declared each selection in the market will be given an appropriate reduction factor. Reduction factors can be amended at Our’s discretion at any time throughout the market life cycle (including post-race).",
            "danger": false
          },
          {
            "text": "For Australian racing, reduction factors may be updated periodically at the discretion of Us based on trading in the market, but after approximately five minutes from the scheduled off time of a given race they will be updated only in exceptional circumstances.",
            "danger": false
          },
          {
            "text": "For Australian racing, reduction factors may be updated periodically at the discretion of Us based on trading in the market, but after approximately five minutes from the scheduled off time of a given race they will be updated only in exceptional circumstances.",
            "danger": false
          },
          {
            "text": "Reductions will be made to both win and place markets but applied differently (as described below), and horses will have a different reduction factor for each market.",
            "danger": false
          },
          {
            "text": "As soon as We becomes aware that a horse is an official non-runner or a highly likely non-runner, following a statement to the press from connections, the following will happen:",
            "danger": true
          },
          {
            "text": "All matched bets on that horse will be void and the horse will be removed from the market.",
            "danger": false
          },
          {
            "text": "In the win market: if the reduction factor of the non-runner is 2.5% or greater, the traded price of all the matched bets on the remaining horses will be reduced by an amount equal to the non-runner's final reduction factor and all the unmatched offers to lay will be cancelled. If the non-runner's reduction factor is less than 2.5%, reductions will not be applied and unmatched bets will not be cancelled.",
            "danger": false
          },
          {
            "text": "In the place market the reduction factor of all non-runners will be applied (even if less than 2.5%) and the potential winnings in relation to matched bets on the remaining horses will be reduced by an amount equal to the non-runner's final reduction factor. Only if the non-runner's reduction factor is 4.0% or greater will all the unmatched offers to lay be cancelled.",
            "danger": false
          },
          {
            "text": "All the reduction factors on the remaining horses will be adjusted to reflect their improved chance of winning.",
            "danger": false
          },
          {
            "text": "Reduction factors are not applied to bets which are struck in-play. However, if a market is turned in-play prematurely by error (or, for example, there is a false start), all bets matched during this time will be subject to any later reduction factor, provided the market is turned out of play before the race commences. In the event of a late withdrawal, We reserves the right to remove the runner after completion of the race. In this case only those bets matched prior to the off will be affected by a reduction factor.",
            "danger": false
          },
          {
            "text": "In the event of a non-runner being removed from a race in error or following incorrect information regarding a runner’s participation, we will reinstate both the runner and all previously matched bets associated with that runner. All bets made between the time of withdrawal and reinstatement will be void in both the place market and the win market. The reduction factor applied to matched bets at the time of withdrawal will be reversed and the original prices will become valid.",
            "danger": false
          },
          {
            "text": "Any non-runners will be removed from the relevant markets in the order in which they are brought to Our's attention. If We becomes aware of more than one non-runner at the same time, it will remove the non-runners from the relevant markets in racecard order.",
            "danger": false
          },
          {
            "text": "Any non-runners will be removed from the relevant markets in the order in which they are brought to Our's attention. If We becomes aware of more than one non-runner at the same time, it will remove the non-runners from the relevant markets in racecard order.",
            "danger": false
          },
          {
            "text": "If a runner is not included in a market because of an error or because of incorrect information regarding a runner’s participation, We reserve the right to introduce the missing runner into the market at any time prior to settlement (even after the race has been run), provided that We are determined that the missing runner is not a material runner (i.e. a selection with a reduction factor of approx. 2.5% or less in the win market). In such circumstances, all pre-play unmatched and matched bets will stand, however if the runner is not introduced before the start of the race, all in-play bets will be void. However, if the missing runner is deemed to be a material runner, then the malformed market will be void and a new market will be loaded where possible.",
            "danger": false
          },
          {
            "text": "3.How the Reductions are applied for Exchange markets",
            "danger": true
          },
          {
            "text": "In the win market, reductions will be made on the traded price. For example: if the non-runner's final reduction factor is 25% the traded price on all previously matched bets on other horses will be reduced by 25% - traded price of 8.0 would become 6.0 etc. And these might be further reduced if another horse is subsequently declared a non-runner.",
            "danger": false
          },
          {
            "text": "In the EW Market, reductions will be made on the traded win price. The advertised place terms will then apply to the revised win prices. For example: if the non-runner's final reduction factor is 25% the traded price on all previously matched bets on other horses will be reduced by 25% - - traded price of 8.0 would become 6.0. If the each Way terms were 1/5th odds for 3 places, the corresponding price for the Place portion of the bet would reduce from 2.4 to 2.0.",
            "danger": false
          },
          {
            "text": "In the place market, reductions will be made to the potential winnings on the bet only, and not the traded price. For example: if the non-runner's final reduction factor is 25% the potential winnings on all previously matched bets on the other horses will be reduced by 25% - a traded price of 8.0 would become 6.25. For example a £10 bet on a horse to be placed at a traded price of 8.0 would provide winnings of £70. If there is a non-runner with a reduction factor of 25% in the race, that factor will be applied to the £70 of potential winnings leaving potential winnings of £52.50. Therefore the revised traded price will be 6.25.",
            "danger": false
          },
          {
            "text": "The traded price may be further reduced if any other horse(s) is subsequently declared a non-runner, however odds cannot be reduced below 1.01.",
            "danger": false
          },
          {
            "text": "Reserves: A reserve runner may appear in the relevant markets but will have a non-applicable reduction factor until we are received confirmation that it is a confirmed runner, in which case an applicable reduction factor may apply to it.",
            "danger": false
          },
          {
            "text": "For the avoidance of doubt, any reduction factor applicable to a non-runner replaced by a reserve, will be applied to all bets struck on the relevant markets, prior to the removal from those markets of such non-runner by Us. Likewise, should a reserve runner become a confirmed runner but subsequently become a non-runner, any reduction factor applicable to such non-runner will be applied to all bets struck on the relevant markets, prior to the removal from those markets of such non-runner by Us.",
            "danger": false
          },
          {
            "text": "4.Additional rules",
            "danger": true
          },
          {
            "text": "Card numbers are posted as a guide only: bets are placed on a named horse.",
            "danger": false
          },
          {
            "text": "Horses will not be coupled.",
            "danger": false
          },
          {
            "text": "Where any horse(s) runs for purse money only it is deemed a non-runner for betting purposes. Should this result in the number of possible winners stated in the relevant Market Information being equal to or greater than the number of runners in the relevant Betfair market, all bets in the market will be void.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "E Games",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "In the event of a match starting but not being completed, then all bets will be void.",
            "danger": true
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Basketball",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match Odds :- Predict which team will be the winner. There must be 5 minutes or less of scheduled game time left for bets to have action.",
            "danger": false
          },
          {
            "text": "Quarter Winner :- The quarter must be completed for bets to have action, unless settlement of bets is already determined.",
            "danger": false
          },
          {
            "text": "1st Half Winner / 2nd Half Winner :- The first half must be completed for first half bets to stand. If a game is postponed or cancelled after the start, for game and second half bets there must be 5 minutes or less remaining for bets to have action, unless settlement of bets is already determined. (Including Overtime if played.)",
            "danger": false
          },
          {
            "text": "Highest Scoring Half :- Predict in which half most points will be scored. OT is not included in 2nd Half.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "MotoGP",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Chess",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Volleyball",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match odds :- Predict which team will be the winner. Bets will be void if the match is not completed.",
            "danger": false
          },
          {
            "text": "Set Winner:- In the event of the set not being completed bets will be void. Exceptions are made for bets on sets which are already over, in this case the bets will be settled.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Ice Hockey",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match Odds Including overtime/shootouts :- Predict the winner of the match including overtime and penalties. The game must be completed for bets to have action.",
            "danger": false
          },
          {
            "text": "Period Winner :- Predict the winner of the relevant period. The relevant period must be completed for bets to have action, unless the specific market outcome is already determined.",
            "danger": false
          },
          {
            "text": "Highest Scoring Period:- If 2 or more periods have the same score Tie will be settled as the winner. (exclude overtime/shootouts for settlement purposes)",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Tennis",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match Odds :-If 1st set has been not completed at the time of the retirement or disqualification, then all bets relating to that individual match will be void.after completion of 1st set in case of retirement the opponent player will be given the winner for match winner bets.",
            "danger": false
          },
          {
            "text": "Game Winner :- Predict which player will win the stated game. The nominated game will be featured in the name of the bet type, for example: 2ndset – 7 th game – Winner. If a game is not completed for any reason, bets on it will be void. Tie break points will not be counted for this bet type. unless the specific market outcome is already determined.",
            "danger": false
          },
          {
            "text": "Under / Over Games :- Finished set stand, the unfinished set can be played to its natural conclusion and settled as in the example: Example: A set is abandoned at 4-4 I win if I placed a bet on Over 9.5 (since any natural conclusion to the set would have at least 10 games); I lost the bet if I placed a bet on Under 9.5 (since any natural conclusion to the set would have at least 10 games); I get my stake back if I placed a bet on O/U 10.5 (it is undecided, the set could have ended 6-4).",
            "danger": false
          },
          {
            "text": "The company reserves the right to suspend or void any ID/bets found to be illegitimate, including cases involving VPN usage, bots/robot use, multiple entries from the same or different IP addresses, exploitation or manipulation of odds in any market, and similar activities. Note: Only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          },
          {
            "text": "“In the event of a technical error or any unforeseen circumstance that leads to the suspension of the Provider’s side of any market (Match_Odds,Over/Under, Game Winner, Point Winner, etc.) during a sporting event, and the market does not resume, the outcome will be settled based on the current result (win/loss) at the time of suspension. All bets placed prior to suspension will remain valid and will be settled accordingly. The company assumes no responsibility or liability for such interruptions or outcomes.”",
            "danger": true
          }
        ]
      }
    ]
  },
  {
    "name": "Badminton",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match_Odds:-Predict which player will win the match. In the event of any of the named players in a match changing before the match starts then all bets are void. In the event of a match starting but not being completed, then all bets will be void.",
            "danger": false
          },
          {
            "text": "Set Winner:-The Set must be completed for bets to stand, unless the specific market outcome is already determined.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": true
          }
        ]
      }
    ]
  },
  {
    "name": "Cycling",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Mixed Martial Arts",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Motorbikes",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Athletics",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": true
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          }
        ]
      }
    ]
  },
  {
    "name": "Basketball 3X3",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Sumo",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Virtual sports",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Handball",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match Odds:- Predict which team will be the winner. Bets will be void if the match is not completed.",
            "danger": false
          },
          {
            "text": "Next Goal:- Predict which team will score the X-th goal.",
            "danger": false
          },
          {
            "text": "Highest Scoring Half:- Predict which half will have the most goals scored (1st, 2nd or Draw). Bet will be settled on regulation time only and exclude overtime if played:",
            "danger": false
          },
          {
            "text": "Halftime/Fulltime:- Predict the result of a match at halftime and at the end of regular time. If a game is abandoned, bets will be void. Example: If you choose 1/X, you bet on the home team to lead in the first half and the match to end in a draw. Extra time doesn’t count.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Cricket",
    "categories": [
      {
        "name": "bookmaker",
        "rules": [
          {
            "text": "1. Due to any reason any team will be getting advantage or disadvantage we are not concerned.",
            "danger": true
          },
          {
            "text": "2. We will simply compare both teams 25 overs score higher score team will be declared winner in ODI (If both teams same score means, low wickets team will be declared winner. In case, both teams same score & same wickets means highest boundaries team will be declared winner.If all same then will be declared No result)",
            "danger": true
          },
          {
            "text": "3. We will simply compare both teams 10 overs higher score team will be declared winner in T20 matches (If both teams same score means, low wickets team will be declared winner. In case, both teams same score & same wickets means highest boundaries team will be declared winner.If all same then will be declared No result)",
            "danger": true
          },
          {
            "text": "4. Any query about the result or rates should be contacted within 7 days of the specific event, the same will not be considered valid post 7 days from the event.",
            "danger": true
          },
          {
            "text": "5. Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of vpn/robot-use/multiple entry from same IP/ multiple bets at the same time (Punching) and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "6. In case, company will find Ground bets, Group betting, Punching bets, Multiple entries with same IP or any fraud or unusual activities are detected then Company will be void winning bets and charge penalty of 2X (Two times) from winning amount.",
            "danger": true
          },
          {
            "text": "7. If two team ends up with equal points, then result will be given based on the official point table",
            "danger": true
          },
          {
            "text": "8. Super Over Bookmaker: If the scores are level at the end of both innings in the Super Over, the same market will continue into subsequent Super Overs until a winner is declared. (This rule applicable from 19th July 2025)",
            "danger": true
          },
          {
            "text": "9. In case technical error or any circumstances any bookmaker is suspended and does not resume result will be given all previous bets will be valid (based on haar/jeet).",
            "danger": true
          },
          {
            "text": "10. If a Match, Series, or League is postponed or rescheduled before any ball is bowled, all bets for that event will be voided. However, if play has already started and the match continues on a reserve day, then all bets will remain valid.",
            "danger": true
          },
          {
            "text": "11. If, for any reason, the trophy is shared between both teams, then all related bets will be voided.",
            "danger": true
          },
          {
            "text": "12. 1-1 Over Bookmaker (IND v PAK)",
            "danger": true
          },
          {
            "text": "13. 1 Over Run IND vs 2 Over Run IND",
            "danger": false
          },
          {
            "text": "14. If Tie then No result",
            "danger": false
          },
          {
            "text": "15. Full Over must be Completed then Only Result will be Valid",
            "danger": false
          },
          {
            "text": "16. If All out then Result is Valid",
            "danger": false
          },
          {
            "text": "17. This Event Running for Every Next Over for Both Innings.",
            "danger": false
          },
          {
            "text": "18. While Running 2nd Innings, If Target Chased in Odd Over means Events will be Deleted. In case of Target Reached on Even Over first ball Means Valid for Result",
            "danger": true
          },
          {
            "text": "19. Example: After 12 over 23 Runs Pending to Chase, 13th Over Target Reached Means 13 and 14 Over Bookmaker will be Deleted. In Case 22 Runs Scored in 13th Over and Target Reached in 14.1 means Event Valid for Result.",
            "danger": false
          },
          {
            "text": "Player Comparison Bookmaker",
            "danger": true
          },
          {
            "text": "If Mentioned Both Player Scored Same Score Means Events will be Deleted.",
            "danger": false
          },
          {
            "text": "Mentioned both Batsman Facing Single Legal Delivery Means Considered For Result",
            "danger": false
          },
          {
            "text": "Example : Match Cancelled after 2.4 Over means If Both Player Facing One Legal Delivery Means Considered for Result. While Playing 2nd Inn Both Player Facing One Legal Delivery Means All Events Considered For Result. If Any Player not Facing Single Delivery Means Particular Player Based Events All Deleted.",
            "danger": false
          }
        ]
      },
      {
        "name": "fancy",
        "rules": [
          {
            "text": "1. All fancy bets will be validated when match has been tied.",
            "danger": true
          },
          {
            "text": "2. All advance fancy will be suspended before toss or weather condition. All advance fancy will be voided if over reduced before match start.",
            "danger": true
          },
          {
            "text": "3. In case technical error or any circumstances any fancy is suspended and does not resume result will be given all previous bets will be valid (based on haar/jeet).",
            "danger": true
          },
          {
            "text": "4. If any case wrong rate has been given in fancy that particular bets will be cancelled.",
            "danger": true
          },
          {
            "text": "5. In any circumstances management decision will be final related to all exchange items. Our scorecard will be considered as valid if there is any mismatch in online portal.",
            "danger": true
          },
          {
            "text": "6. In case customer make bets in wrong fancy we are not liable to delete. No changes will be made and bets will be consider as confirm bet.",
            "danger": true
          },
          {
            "text": "7. Due to any technical error market is open and result has came all bets after result will be deleted.",
            "danger": true
          },
          {
            "text": "8. Manual bets are not accepted in our exchange.",
            "danger": true
          },
          {
            "text": "9.Our exchange will provide 5 second delay in our TV.",
            "danger": true
          },
          {
            "text": "10. Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "11. Company reserves the right to void any bets (only winning bets) of any event at any point of the match if the company believes there is any cheating/wrong doing in that particular event by the players (either batsman/bowler)",
            "danger": true
          },
          {
            "text": "12. Once our exchange give username and password it is your responsibility to change a password.",
            "danger": true
          },
          {
            "text": "13. Penalty runs will be counted in all fancy. (This rule applicable from 20th March 2024)",
            "danger": true
          },
          {
            "text": "14. Warning:- live scores and other data on this site is sourced from third party feeds and may be subject to time delays and/or be inaccurate. If you rely on this data to place bets, you do so at your own risk. Our exchange does not accept responsibility for loss suffered as a result of reliance on this data.",
            "danger": true
          },
          {
            "text": "15. Traders will be block the user ID if find any misinterpret activities, No queries accept regarding.",
            "danger": true
          },
          {
            "text": "16. Company will not delete No ball and Short run bets below amount of INR.10k. It's will be delete only INR 10k,PKR 30000,BDT 15000,USD 100,HKD 1000,AED 500,SLR 30000,GBP 100 and above amount. Company reserves the right to delete any bets including below 10k also if found to be Ground bets. (This rule applicable from IST 19:00 Hours on 1st May 2025)",
            "danger": true
          },
          {
            "text": "17. Our exchange is not responsible for misuse of client id.",
            "danger": true
          },
          {
            "text": "18.In case, company will find Ground bets, Group betting, Punching bets, Multiple entries with same IP or any fraud or unusual activities are detected then Company will be void winning bets and charge penalty of 2X (Two times) from winning amount.",
            "danger": true
          },
          {
            "text": "TEST",
            "danger": true
          },
          {
            "text": "1 Session:-",
            "danger": true
          },
          {
            "text": "1.1 Complete session valid in test.",
            "danger": false
          },
          {
            "text": "1.2 Middle session and Session is not completed due to Innings declared or all out so that particular over considered as completed and remaining over counted in next team Innings for ex:- In case of Innings declared or all out In 131.5th over Considered as 132 over completed remaining 1 over counted for 133 over middle session and 3 over counted for 135 over session from next team Innings and One over session and Only over session is not completed due to innings declared so that Particular over session bets will be deleted and all out considered as valid for ex:- In case of Innings declared In 131.5th over so 132 over will be deleted and if all out then 132 over and Only 132 over will be Valid.",
            "danger": false
          },
          {
            "text": "1.3 1st day 1st session run minimum 25 over will be played then result is given otherwise 1st day 1st session will be deleted.",
            "danger": false
          },
          {
            "text": "1.4 1st day 2nd session run minimum 25 over will be played then result is given otherwise 1st day 2nd session will be deleted.",
            "danger": false
          },
          {
            "text": "1.5 1st day total run minimum 80 over will be played then result is given otherwise 1st day total run will be deleted. If a team get All Out before the day stumps, the other team's 1st day score will be added to 1st day total run event. (i.e. AUSTRALIA got all out at 251 before the day stumps, then ENGLAND hit 100 runs in the remaining overs of 1st day, so the result of 1st day total run event will be 351)",
            "danger": false
          },
          {
            "text": "1.6 Test match both advance session is valid.",
            "danger": false
          },
          {
            "text": "2 Test lambi/ Inning run:-",
            "danger": true
          },
          {
            "text": "2.1 Mandatory 70 over played in test lambi paari/ Innings run. If any team all-out or declaration lambi paari/ innings run is valid.",
            "danger": false
          },
          {
            "text": "2.2 In case due to weather situation match has been stopped all lambi trades will be deleted.",
            "danger": false
          },
          {
            "text": "2.3 In test both lambi paari / inning run is valid in advance fancy.",
            "danger": false
          },
          {
            "text": "3 Test batsman:-",
            "danger": true
          },
          {
            "text": "3.1 In case batsmen is injured he/she is made 34 runs the result will be given 34 runs.",
            "danger": false
          },
          {
            "text": "3.2 Batsman 50/100 run if batsman is injured or declaration the result will be given on particular run.",
            "danger": false
          },
          {
            "text": "3.3 In next men out fancy if player is injured particular fancy will be deleted.",
            "danger": false
          },
          {
            "text": "3.4 In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.",
            "danger": false
          },
          {
            "text": "3.5 Test match both advance fancy batsmen run is valid.",
            "danger": false
          },
          {
            "text": "4 Test partnership:-",
            "danger": true
          },
          {
            "text": "4.1 In partnership one batsman is injured or Retired out means partnership will continued in next batsman.",
            "danger": false
          },
          {
            "text": "4.2 Partnership and player runs due to weather condition or match abandoned or match completed, then the result will be given as per score.",
            "danger": false
          },
          {
            "text": "4.3 Advance partnership is valid in case both players are different or same.",
            "danger": false
          },
          {
            "text": "4.4 Test match both advance fancy partnership is valid.",
            "danger": false
          },
          {
            "text": "5 Other fancy advance (test):-",
            "danger": true
          },
          {
            "text": "5.1 Four, sixes, wide, wicket, extra run, total run, highest over and top batsmen is valid only if 300 overs has been played or the match has been won by any team otherwise all these fancy will be deleted. Additionally all events are valid only for 1st innings( this is applicable to all individual team events also)",
            "danger": false
          },
          {
            "text": "2 Odi rule:-",
            "danger": true
          },
          {
            "text": "Session:-",
            "danger": true
          },
          {
            "text": "Match 1st over run advance fancy only 1st innings run will be counted.",
            "danger": false
          },
          {
            "text": "Complete session is valid in case due to rain or match abandoned particular session will be deleted.",
            "danger": false
          },
          {
            "text": "For example:- 35 over run team a is playing any case team A is all-out in 33 over team a has made 150 run the session result is validated on particular run.",
            "danger": false
          },
          {
            "text": "Advance session is valid in only 1st innings.",
            "danger": false
          },
          {
            "text": "50 over runs:-",
            "danger": true
          },
          {
            "text": "In case 50 over is not completed all bet will be deleted due to weather or any condition.",
            "danger": false
          },
          {
            "text": "Advance 50 over runs is valid in only 1st innings.",
            "danger": false
          },
          {
            "text": "Odi batsman runs:-",
            "danger": true
          },
          {
            "text": "In case batsman is injured he/she is made 34 runs the result will be given 34 runs.",
            "danger": false
          },
          {
            "text": "In next men out fancy if player is injured particular fancy will be deleted.",
            "danger": false
          },
          {
            "text": "In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.",
            "danger": false
          },
          {
            "text": "Odi partnership runs:-",
            "danger": true
          },
          {
            "text": "In partnership one batsman is injured or Retired out means partnership will continued in next batsman.",
            "danger": false
          },
          {
            "text": "Advance partnership is valid in case both players are different or same.",
            "danger": false
          },
          {
            "text": "Both team advance partnerships are valid in particular match.",
            "danger": false
          },
          {
            "text": "Other fancy:-",
            "danger": true
          },
          {
            "text": "Four, sixes, wide, wicket, extra run, total run, highest over ,top batsman,maiden over,caught-out,no-ball,run-out,fifty and century are valid only match has been completed in case due to rain over has been reduced all other fancy will be deleted.",
            "danger": false
          },
          {
            "text": "T20:-",
            "danger": true
          },
          {
            "text": "Session:-",
            "danger": true
          },
          {
            "text": "Match 1st over run advance fancy only 1st innings run will be counted.",
            "danger": false
          },
          {
            "text": "Complete session is valid in case due to rain or match abandoned particular session will be deleted.",
            "danger": false
          },
          {
            "text": "For example :- 15 over run team a is playing any case team a is all-out in 13 over team A has made 100 run the session result is validated on particular run.",
            "danger": false
          },
          {
            "text": "Advance session is valid in only 1st innings.",
            "danger": false
          },
          {
            "text": "20 over runs:-",
            "danger": true
          },
          {
            "text": "Advance 20 over run is valid only in 1st innings. 20 over run will not be considered as valid if 20 overs is not completed due to any situation.",
            "danger": false
          },
          {
            "text": "3.) No ball free hit ball bets will be voided.",
            "danger": false
          },
          {
            "text": "Badla Rule:",
            "danger": true
          },
          {
            "text": "1.) Our session rate 45/46 means you can chances to bet 5 upper and down badla rate (Ex: Badla Down rate 40,41,42,43,44 and Badla Upper rate 47,48,49,50,51).",
            "danger": false
          },
          {
            "text": "If the result is your chosen badla rate, you will make a profit. If the result is our rate, you will make a loss. If any other results all badla bets will be voided.",
            "danger": false
          },
          {
            "text": "2.) If session rate 45.110.90 then you can chances to bet only upper badla value. (Ex: Upper badla value is 46,47,48,49,50).",
            "danger": false
          },
          {
            "text": "If the result is your chosen badla rate, you will get 90% profit. If the result is our rate, you will get 110% loss.",
            "danger": false
          },
          {
            "text": "T20 batsman runs:-",
            "danger": true
          },
          {
            "text": "In case batsman is injured he/she is made 34 runs the result will be given 34 runs.",
            "danger": false
          },
          {
            "text": "In next men out fancy if player is injured particular fancy will be deleted.",
            "danger": false
          },
          {
            "text": "In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.",
            "danger": false
          },
          {
            "text": "T20 partnership runs:-",
            "danger": true
          },
          {
            "text": "In partnership one batsman is injured or Retired out means partnership will continued in next batsman.",
            "danger": false
          },
          {
            "text": "Advance partnership is valid in case both players are different or same.",
            "danger": false
          },
          {
            "text": "Both team advance partnerships are valid in particular match.",
            "danger": false
          },
          {
            "text": "1st 2 & 3 & 4 Wickets runs:- T20/ODI",
            "danger": true
          },
          {
            "text": "Advance event is valid in only 1st Innings.",
            "danger": false
          },
          {
            "text": "If over reduced due to rain or weather condition or match abandoned or match completed, then the result will be given as per score.",
            "danger": false
          },
          {
            "text": "Other fancy:-",
            "danger": true
          },
          {
            "text": "T-20 ,one day and test match in case current innings player and partnership are running in between match has been called off or abandoned that situation all current player and partnership results are valid.",
            "danger": false
          },
          {
            "text": "Four, sixes, wide, wicket, extra run, total run, highest over and top batsman,maiden over,caught-out,no-ball,run-out,fifty and century are valid only match has been completed in case due to rain over has been reduced all other fancy will be deleted. 1st 6 over dot ball and 20 over dot ball fancy only valid is 1st innings.",
            "danger": false
          },
          {
            "text": "1st wicket lost to any team balls meaning that any team 1st wicket fall down in how many balls that particular fancy at least minimum one ball have to be played otherwise bets will be deleted.",
            "danger": false
          },
          {
            "text": "1st wicket lost to any team fancy valid both innings.",
            "danger": false
          },
          {
            "text": "How many balls for 50 runs any team meaning that any team achieved 50 runs in how many balls that particular fancy at least one ball have to be played otherwise that fancy bets will be deleted.",
            "danger": false
          },
          {
            "text": "How many balls for 50 runs fancy any team only first inning valid.",
            "danger": false
          },
          {
            "text": "1st 6 inning boundaries runs any team fancy will be counting only according to run scored fours and sixes at least 6 over must be played otherwise that fancy will be deleted.",
            "danger": false
          },
          {
            "text": "1st inning 6 over boundaries runs any team run like wide ,no-ball ,leg-byes ,byes and over throw runs are not counted this fancy.",
            "danger": false
          },
          {
            "text": "How many balls face any batsman meaning that any batsman how many balls he/she played that particular fancy at least one ball have to be played otherwise that fancy bets will be deleted.",
            "danger": false
          },
          {
            "text": "How many balls face by any batsman both innings valid.",
            "danger": false
          },
          {
            "text": "Lowest scoring over will be considered valid only if the over is completed fully (all six deliveries has to be bowled)",
            "danger": false
          },
          {
            "text": "Total Wickets: If a Batsman Retired hurt or Retired out means It will not be Counted in Total Wicket.",
            "danger": false
          },
          {
            "text": "Most 4s in Single Over: Maximum number of 4s hit in a single over of the Match. No ball 4s will be counted. Byes & Leg byes 4s will not be counted.",
            "danger": false
          },
          {
            "text": "Most 6s in Single Over : Maximum number of 6s hit in a Single over of the Match. No ball 6s will be counted.",
            "danger": false
          },
          {
            "text": "Total No Boundaries over’s: Number of over’s where no boundaries (fours or sixes) are scored. If a team all out or Match Resulted in 15.1 then considered as 16 over. Team wise 1st Innings only Considered. Total Match means Both Innings will be considered.",
            "danger": false
          },
          {
            "text": "Total Impact over’s: Number of over’s scored 10 runs or above. If a team all out or Match Resulted in 15.1 then considered as 16 over. Team wise 1st Innings only Considered. Total Match means Both Innings will be considered.",
            "danger": false
          },
          {
            "text": "Total Reviews Taken in Full Match: Number of Reviews taken in full match. Wickets, Wide & No ball Reviews will be Considered.",
            "danger": false
          },
          {
            "text": "Total Match Successful Reviews: Number of Reviews are Successful. Successful means Original decision must be changed.",
            "danger": false
          },
          {
            "text": "Total Match Unsuccessful Reviews: Number of Reviews are Unsuccessful. Unsuccessful means Original decision same after DRS.",
            "danger": false
          },
          {
            "text": "Total Reviews Resulted Umpire's Call: Number of Reviews Resulted Umpire's Call during the Wicket Review.",
            "danger": false
          },
          {
            "text": "Total Reviews Taken by Batting Team: Number of Reviews taken by batting team. Both Innings will be Considered.",
            "danger": false
          },
          {
            "text": "Total Reviews Taken by Bowling Team: Number of Reviews taken by bowling team. Both Innings will be Considered.",
            "danger": false
          },
          {
            "text": "Total Reviews Taken by Team: Number of Reviews taken by Particular team during Batting and Bowling.",
            "danger": false
          },
          {
            "text": "Total Match 30s : How many batsman's scored 30 to 49 runs in full match. If a Player reached 50 means, Not considered in this Event.",
            "danger": false
          },
          {
            "text": "Total Boundaries in 1st Power play : Number of Boundaries Scored in 1st Power play, 1st Innings only Valid In T20/ODI Both",
            "danger": false
          },
          {
            "text": "Total Dot balls in 1st Power play : Number of Dot balls coming in 1st Power play, 1st Innings only Valid In T20/ODI Both",
            "danger": false
          },
          {
            "text": "Total match Wicket keeper's Dismissals: Wicket keepers Caught outs and Stumping Only Considered In T20/ODI Both",
            "danger": false
          },
          {
            "text": "1st Inn Death Over Runs : Runs Scored, Last Over Only Considered, 1st Innings only Valid",
            "danger": false
          },
          {
            "text": "Total Match Single Digit Scores By Players : Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
            "danger": false
          },
          {
            "text": "Most Balls Faced By a Batsman : Maximum Balls Faced by an Individual Batsman in Match",
            "danger": false
          },
          {
            "text": "High Pship Boundaries in the Match : Maximum Number of Boundaries Scored during any Partnership",
            "danger": false
          },
          {
            "text": "Total Impact over’s: Number of over’s scored 10 runs or above. If a team all out or Match Resulted in 15.1 then considered as 16 over. Team wise only 1st inning are valid and Match wise both innings are valid.",
            "danger": false
          },
          {
            "text": "Total Match Four Hitters : Number of Batsman hitting Fours in full match.",
            "danger": false
          },
          {
            "text": "Total Match Six Hitters : Number of Batsman hitting Sixes in full match.",
            "danger": false
          },
          {
            "text": "Total Match Wicket Takers : Number of bowlers taking wickets in full match.",
            "danger": false
          },
          {
            "text": "100 balls Event: The events for 1 to 100 balls will be considered valid only if the number of balls mentioned has been played completely. However if the balls got reduced before the particular event then the same will be voided, if the team batting first get all out prior to 100 balls the balance balls will be counted from second innings. For example if team batting first gets all out in 81 balls balance 19 balls will be counted from second innings and that 19 balls all events are counted. This same is valid for 1st Innings only.",
            "danger": false
          },
          {
            "text": "Concussion in Test:-",
            "danger": true
          },
          {
            "text": "All bets of one over session will be deleted in test scenario, in case session is incomplete. For example innings declared or match suspended to bad light or any other conditions.",
            "danger": false
          },
          {
            "text": "1. All bets will be considered as valid if a player has been replaced under concussion substitute, result will be given for the runs scored by the mentioned player. For example DM Bravo gets retired hurt at 23 runs, then result will be given for 23.",
            "danger": false
          },
          {
            "text": "2. Bets of both the player will be valid under concussion substitute.",
            "danger": false
          },
          {
            "text": "Line Market :-",
            "danger": true
          },
          {
            "text": "The result will be given of the particular Line Market only if the mentioned over is completed or the batting team is bowled out(All Out) or the target is chased down.",
            "danger": false
          },
          {
            "text": "Note : Penalty runs will be included in all the Line Markets.",
            "danger": true
          },
          {
            "text": "Total Match- Events (test):-",
            "danger": true
          },
          {
            "text": "Minimum of 300 overs to be bowled in the entire test match, otherwise all bets related to the particular event will get void. For example, Total match caught outs will be valid only if 300 overs been bowled in the particular test match",
            "danger": false
          },
          {
            "text": "Limited over events-Test:-",
            "danger": true
          },
          {
            "text": "This event will be considered valid only if the number of overs defined on the particular event has been bowled, otherwise all bets related to this event will get void. For example 0-25 over events will be valid only if 25 overs has been bowled, else the same will not be considered as valid",
            "danger": false
          },
          {
            "text": "If the team gets all out prior to any of the defined overs, then balance overs will be counted in next innings. For example if the team gets all out in 23.1 over the same will be considered as 24 overs and the balance overs will be counted from next innings.",
            "danger": false
          },
          {
            "text": "Bowler Wicket event's- Test:-",
            "danger": true
          },
          {
            "text": "Minimum of one legal over (one complete over) has to be bowled by the bowler mentioned in the event, else the same will not be considered as valid.",
            "danger": false
          },
          {
            "text": "Player ball event's- Test:-",
            "danger": true
          },
          {
            "text": "This event will be considered valid only if the defined number of runs made by the mentioned player, else the result will be considered as 0 (zero) balls.",
            "danger": false
          },
          {
            "text": "For example if Root makes 20 runs in 60 balls and gets out on 22 runs, result for 20 runs will be 60 balls and the result for balls required for 25 run Root will be considered as 0 (Zero) and the same will be given as result",
            "danger": false
          },
          {
            "text": "Limited over events-ODI:-",
            "danger": true
          },
          {
            "text": "This event will be considered valid only if the number of overs defined on the particular event has been bowled, otherwise all bets related to this event will get void. 0-50 over events will be valid only if 50 over completed, if the team batting first get all out prior to 50 over the balance over will be counted from second innings. For example if team batting first gets all out in 35 over balance 15 over will be counted from second innings, the same applies for all events if team gets all out before the defined number of overs.",
            "danger": false
          },
          {
            "text": "The events which remains incomplete will be voided if over gets reduced in the match due to any situation, for example if match interrupted in 15 overs due to rain/badlight and post this over gets reduced. Events for 0-10 will be valid, all other events related to this type will get deleted.",
            "danger": false
          },
          {
            "text": "This events will be valid only if the defined number of over is completed. For example team batting first gets all out in 29.4 over then the same will be considered as 30 over, the team batting second must complete 20 overs only then 0-50 over events will be considered as valid. In case team batting second gets all out in 19.4 over then 0-50 over event will not be considered as valid, This same is valid for 1st Innings only.",
            "danger": false
          },
          {
            "text": "Bowler Session:",
            "danger": true
          },
          {
            "text": "Advance Event Valid Only for 1st Innings.",
            "danger": false
          },
          {
            "text": "Wide,Noball and Over throw Considered for Bowler Runs in Bowler Session.",
            "danger": false
          },
          {
            "text": "Wickets,Leg byes and Byes are Considered as Dotball in Bowler Session.",
            "danger": false
          },
          {
            "text": "Mentioned Bowler has to Complete the Defined Number of Overs, Otherwise Particular Over Based Events will be Voided.",
            "danger": false
          },
          {
            "text": "However, if the match has Resulted and the Particular Bowler has already Started bowling his Final over then result will be given even If He haven't Completed his Final over.",
            "danger": false
          },
          {
            "text": "For Over Reduced or Abandoned Match this will not Considered.",
            "danger": false
          },
          {
            "text": "For Example : Bowler A is Bowling his final over and at 3.4 the match has Resulted then Result will be given for Bowler A 4 over runs.",
            "danger": false
          },
          {
            "text": "Due to Rain Over Reducing or Abandoning in between the match Means Bowler Session Considered for Only Completed Overs Before Over Reduce or Abandoning the Match",
            "danger": false
          },
          {
            "text": "Example: Match Stopped at 14th Over, at the time Bowler A Complete his 4 Over and Bowler B Complete 3.2 Over Means Bowler A 2 Over and 4 Over Will be Considered for Result and Bowler B 2 Over Only Valid for Result.",
            "danger": false
          },
          {
            "text": "Other event:- T20",
            "danger": true
          },
          {
            "text": "The events for 1-10 over and 11-20 over will be considered valid only if the number of over mentioned has been played completely. However if the over got reduced before the particular event then the same will be voided, if the team batting first get all out prior to 20 over the balance over will be counted from second innings. For example if team batting first gets all out in 17 over balance 3 over will be counted from second innings and that 3 over all events are counted. This same is valid for 1st Innings only.",
            "danger": false
          },
          {
            "text": "If over got reduced in between any running event, then the same will be considered valid and the rest will be voided. For example.., match started and due to rain/bad light or any other situation match got interrupted at 4 over and later over got reduced. Then events for 1-10 is valid rest all will be voided",
            "danger": false
          },
          {
            "text": "Dot ball Event:",
            "danger": true
          },
          {
            "text": "Only No run will count as dot ball.",
            "danger": false
          },
          {
            "text": "If wicket means that will not count as dot ball.",
            "danger": false
          },
          {
            "text": "Most Dot balls By a Bowler Event:",
            "danger": true
          },
          {
            "text": "Leg bye run and wickets considered as Dot ball in bowler",
            "danger": false
          },
          {
            "text": "Boundary on Match 1st Free hit",
            "danger": true
          },
          {
            "text": "Both innings are valid",
            "danger": false
          },
          {
            "text": "Boundary hit on Free hit only be considered as valid",
            "danger": false
          },
          {
            "text": "Bets will be deleted if there is no Free hit in the mentioned match",
            "danger": false
          },
          {
            "text": "Boundary by bat will be considered as valid",
            "danger": false
          },
          {
            "text": "Boundaries by Player",
            "danger": true
          },
          {
            "text": "Both Four and six are valid",
            "danger": false
          },
          {
            "text": "No Boundaries Event:",
            "danger": true
          },
          {
            "text": "Both Four and Six are valid",
            "danger": false
          },
          {
            "text": "Batsman bat boundaries only considered as valid",
            "danger": false
          },
          {
            "text": "Free hit boundaries also valid",
            "danger": false
          },
          {
            "text": "Bets will be voided if that particular ball not completed",
            "danger": false
          },
          {
            "text": "Result will be given 0 or 4 (No or Yes). For Example batsman hit boundary in particular ball means Result is 0 otherwise Result is 4.",
            "danger": false
          },
          {
            "text": "Two boundaries bhav in Single over:",
            "danger": true
          },
          {
            "text": "Both Four and Six are valid",
            "danger": false
          },
          {
            "text": "Batsman bat boundaries only considered as valid",
            "danger": false
          },
          {
            "text": "Free hit boundaries also valid",
            "danger": false
          },
          {
            "text": "Incomplete over bets will be deleted. Incase Two boundaries hit before over completed then valid.",
            "danger": false
          },
          {
            "text": "Result will be given 2 or 0 (Yes or No). For Example batsman hits two boundaries in particular over Result is 2 otherwise Result is 0.",
            "danger": false
          },
          {
            "text": "Inning Run Bhav Event :",
            "danger": true
          },
          {
            "text": "Inning run bhav bets are valid if over reduced due to rain or weather condition or match abandoned the result will be given as per official result.",
            "danger": false
          },
          {
            "text": "Settlement occurs once the stipulated conditions are met, which involves either completion of the allotted overs or the batting team's dismissal, including weather disturbances.",
            "danger": false
          },
          {
            "text": "In the event of a weather-shortened match, all Bhav Bets placed in the Inning Run Bhav market will be settled according to the official result. For limited overs matches, this includes results determined by the Duckworth Lewis method.",
            "danger": false
          },
          {
            "text": "In case of pitch vandalism, player safety concerns, stadium damage, acts of terrorism, or acts of God, the company holds the authority to nullify all bets, with the exception of those related to markets that have already been conclusively settled.",
            "danger": false
          },
          {
            "text": "Bets made during instances of incorrect scorecard updates, inaccurate commentary, delays in suspending the Bhav Bets of Total Innings Runs market, or erroneous updates of rates and odds for Bhav Bets in Total Innings Runs will be removed and deleted from user accounts.",
            "danger": false
          },
          {
            "text": "Ex: 1st inning run bhav(ENG v AUS),2nd Inning run bhav(ENG v AUS) - England vs Australia T20 Match",
            "danger": false
          },
          {
            "text": "Power Surge Rule in Big Bash",
            "danger": true
          },
          {
            "text": "Power Play First Four Overs + Power Surge Two Overs-Batters Choice",
            "danger": false
          },
          {
            "text": "The batting side chooses when to take control with the addition of the Power Surge.",
            "danger": false
          },
          {
            "text": "There’s still a four-over power play at the start of the innings, but now the batting team can take the other two Power Surge overs any time from the 11th over onwards.",
            "danger": false
          },
          {
            "text": "Total Runs in Match:",
            "danger": true
          },
          {
            "text": "1. This market is based on how many runs will be scored in the match across both team’s innings combined.",
            "danger": false
          },
          {
            "text": "2. Penalty runs will be counted.",
            "danger": false
          },
          {
            "text": "3. Total Runs in Match, bets will be voided if over reduced in 1st inning or 2nd inning due to weather condition.",
            "danger": false
          },
          {
            "text": "4. The following number of over’s must be bowled otherwise all bets are void. T20-40 over’s / Odi-100 over’s, if team gets all out before the defined number of over’s then valid.",
            "danger": false
          },
          {
            "text": "5. In case match shortened due to weather condition, a new event will be start of the allotted over’s announced.",
            "danger": false
          },
          {
            "text": "Total runs: This market is based on how many runs will be scored in the match across both team's innings combined.",
            "danger": false
          },
          {
            "text": "Total Over’s: This market is based on how many over’s will be played in the match across both team's innings combined. (If an Inning completed in 83.4 over’s then that calculated as 84 over)",
            "danger": false
          },
          {
            "text": "Total Bowlers Giving 100 runs: Number of Bowlers Giving 100 runs and above per innings. Both innings will be counted.",
            "danger": false
          },
          {
            "text": "Any query regarding result or rate has to be contacted within 7 days from the event; query after 7 days from the event will not be considered as valid",
            "danger": true
          },
          {
            "text": "Women's Big Bash League",
            "danger": true
          },
          {
            "text": "If WBBL fixture of 43 matches gets reduced due to any reason, then all the special fancies will be voided (Match abandoned due to rain/bad light will not be considered in this)",
            "danger": true
          },
          {
            "text": "At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid, similarly if the tournament gets canceled due to any reason the previously given result will be considered valid",
            "danger": true
          },
          {
            "text": "Management decision will be final",
            "danger": true
          },
          {
            "text": "1. Highest innings run - Only First innings is valid",
            "danger": false
          },
          {
            "text": "2. Highest Partnership Run: Both Innings are valid",
            "danger": false
          },
          {
            "text": "3. Highest Run Scorer Runs: Total Runs Scored by An Individual Batsman in Full Tournament. (WBBL Golden Bat).",
            "danger": false
          },
          {
            "text": "4. Total 4's: Average 30 Fours will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "5. Total 6's: Average 5 Sixes will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "6. Total Boundaries: Average 35 Boundaries will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "7. Total 30's: Average 2 Thirties will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "8. Total 50's: Average 1 Fifties will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "9. Total Wickets - Average will 13 Wickets be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "10. Total Wides - Average 9 Wides will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "11. Total No balls:- Average 1 No ball will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "12. Total Extras - Average 16 Extras will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "13. Total Caught outs: Average 8 Caught out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "14. Total Bowled:- Average 2 Bowled out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "15. Total LBW:- Average 1 LBW will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "16. Total Run out:- Average 1 Run out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "17. Total Duckouts : Average 1 Duckout will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "18. Total Single Digit Scorers : Average 7 Single Digit Scorers will be given in case match abandoned or over reduced. Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
            "danger": false
          },
          {
            "text": "19. Total Double Digit Scorers: Average 8 Double Digit Scorers will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "20. Total of Impact Overs : Average 10 Impact Overs will be given in case match abandoned or over reduced. Number of over’s scored 10 runs and above. If a team all out or Match Resulted in 15.1 then considered as 16 over.",
            "danger": false
          },
          {
            "text": "21. Total 50+ Partnerships - Average 2 Fifty plus Partnerships will be given in case match abandoned or over reduced. 50 and 50 Above Partnerships All Counted in this.",
            "danger": false
          },
          {
            "text": "22. Highest 1st 6 over run: Both Innings are Valid.Will not consider if over reduce before completion 6 over.",
            "danger": false
          },
          {
            "text": "23. Highest 1st 10 over run : Both Innings are Valid.Will not consider if over reduce before completion 10 over.",
            "danger": false
          },
          {
            "text": "24. Highest 4s,6s,30s,50s,Wickets,Wides,Extras,Caught Outs,Bowled,Lbw, Runouts, Duckouts,Single Digit Scorers,Double Digit Scorers, 50+ Pships and Imapact Overs in individual match: All Both innings are Counted.",
            "danger": false
          },
          {
            "text": "25. Highest Scoring Over Runs : Maximum Runs Scored in any Single Over in Full Tournament.",
            "danger": false
          },
          {
            "text": "26. Most 4s,6s,Boundaries,30s,50s,Wides, Extras,Caught Outs,Bowled,Duckouts and Impact Overs in an Innings Of the Match : Considered For Any Innings.All Both Innings Considered as Valid",
            "danger": false
          },
          {
            "text": "27. Most 4's by individual batsman in a Match : Maximum 4s Hitted by an Individual Batsman in any Single Match",
            "danger": false
          },
          {
            "text": "28. Most 6's by individual batsman in a Match : Maximum 6s Hitted by an Individual Batsman in any Single Match",
            "danger": false
          },
          {
            "text": "29. Most Balls Faced By a Batsman : Maximum balls Faced by an Individual Batsman in the Single Match.",
            "danger": false
          },
          {
            "text": "30. Most runs given by Bowler in an Inning : Maximum Runs conceded by a individual Bowler in an Innings.",
            "danger": false
          },
          {
            "text": "31. Most wickets by Bowler in an inning : Maximum Wickets taken by a individual Bowler in an Innings",
            "danger": false
          },
          {
            "text": "32. \"If the match starts as a 20 Over game, after the balls are reduced due to rain interrupting means comparison Events like Highest 4s,6s, boundaries,30s,50s, Wickets,Wides,Extras,Caughtouts,Bowled,Lbw,Runout,Duckout,Single Digit Scorers, Double Digit Scorers and Most 4s,6s,boundaries,30s,50s, Caught outs,Bowled,Duckout, wicket Keeper Dismissals all are considered for Result. Example : If a match started as 20 Overs game after rain Overs reduced to 16 Overs match, in that match Maximum 6s reached means that Value considered for Result of Highest 6s in Individual Match.\"",
            "danger": false
          },
          {
            "text": "33. \"Due to Rain match started as Overs reduced match all the comparison Events not considered for Result. Example: Due to Rain match only 8 Overs both side Means Maximum Single Digit Scorers reached maximum in that match means Not considered for Result.\"",
            "danger": false
          },
          {
            "text": "34. Super over will not be included.",
            "danger": false
          },
          {
            "text": "35. Lowest innings run (1st Inn) - Only First innings is valid. 1st Inning playing team must be Played 20 Overs or If team get all out means Only considered.",
            "danger": false
          },
          {
            "text": "36. Lowest innings run (Both Inn) - Both innings are valid.",
            "danger": false
          },
          {
            "text": "Special Events:",
            "danger": true
          },
          {
            "text": "At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid, similarly if the tournament gets canceled due to any reason the previously given result will be considered valid",
            "danger": true
          },
          {
            "text": "Women's Premier League (WPL) Special 2026",
            "danger": true
          },
          {
            "text": "If WPL fixture of 22 matches gets reduced due to any reason, then all the special fancies will be voided (Match abandoned due to rain/bad light will not be considered in this)",
            "danger": true
          },
          {
            "text": "At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid, similarly if the tournament gets canceled due to any reason the previously given result will be considered valid",
            "danger": true
          },
          {
            "text": "Management Decision will be Final",
            "danger": true
          },
          {
            "text": "Highest Innings run - Only First Innings is Valid",
            "danger": false
          },
          {
            "text": "Lowest Innings run - Only First Innings is Valid",
            "danger": false
          },
          {
            "text": "Highest Total Runs of WPL: Maximum Runs Scored by 2 Teams in Single Match.",
            "danger": false
          },
          {
            "text": "Highest Partnership Runs in WPL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "Highest Partnership Balls in WPL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "In fastest fifty always the first 50 runs will be considered, for example of S Smith scores 1st fifty in 17 balls and scores 100 in next 14 balls, fastest 50 will be given based on the balls for the 1st fifty runs",
            "danger": true
          },
          {
            "text": "Highest Run Scorer Runs : Total Runs Scored by An Individual Batsman in Full Tournament (ORANGE CAP)",
            "danger": false
          },
          {
            "text": "Highest Wicket Taker Wickets: Total Wickets Taken by a Bowler in Full Tournament (PURPLE CAP)",
            "danger": false
          },
          {
            "text": "Total Match 1st Over Runs : Average 6 Runs will be given in case match abandoned or over reduced. 1st Inn Only Considered.",
            "danger": false
          },
          {
            "text": "Total 4's: Average 34 Fours will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Wickets - Average will 12 Wickets be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Wides - Average 8 Wides will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Extras - Average 14 Extras will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Caught outs: Average 8 Caught out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Bowled:- Average 2 Bowled out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total LBW:- Average 1 LBW will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Run out:- Average 1 Run out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total 30's: Average 2 Thirties will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total 50's: Average 1 Fifties will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Duckouts : Average 1 Duckout will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Single Digit Scorers : Average 6 Single Digit Scorers will be given in case match abandoned or over reduced. Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
            "danger": false
          },
          {
            "text": "Total Double Digit Scorers: Average 8 Double Digit Scorers will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Four Hitters in WPL : Average 10 Four Hitter will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Six Hitters in WPL : Average 4 Six Hitter will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Wicket Takers in WPL : Average 7 Wicket Taker will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Highest 1st Over Runs : 1st Inn Only Valid.",
            "danger": false
          },
          {
            "text": "Highest 1st 6 over run: 1st Inn Only Valid. Will not consider if over reduce before completion 6 over.",
            "danger": false
          },
          {
            "text": "Highest 4s,Wickets,Wides and Extras in individual match: All Both innings are Counted.",
            "danger": false
          },
          {
            "text": "Highest Scoring Over Runs : Maximum Runs Scored in any Single Over in Full Tournament.",
            "danger": false
          },
          {
            "text": "Most Balls Faced By a Batsman : Maximum balls Faced by an Individual Batsman in the Single Match.",
            "danger": false
          },
          {
            "text": "Most 4s Hit by a Batsman in Innings of WPL : Maximum 4s Hitted by an Individual Batsman in any Single Innings",
            "danger": false
          },
          {
            "text": "Most Dotballs By a Bowler in an Inn of WPL : Maximum Dotballs By Single Bowler in His 4 Overs.",
            "danger": false
          },
          {
            "text": "Most runs given by Bowler in an Inning : Maximum Runs conceded by a individual Bowler in an Innings.",
            "danger": false
          },
          {
            "text": "Most wickets by Bowler in an inning : Maximum Wickets taken by a individual Bowler in an Innings",
            "danger": false
          },
          {
            "text": "If the match starts Over Reduced Game or 20 Over Game, after the balls are reduced due to rain interrupting means comparison Events like Highest 4s,6s, boundaries,30s,50s, Wickets,Wides,Extras,Caughtouts,Bowled,Lbw,Runout,Duckout,Single Digit Scorers, Double Digit Scorers and Most 4s,6s,boundaries,30s,50s, Caught outs,Bowled,Duckout, wicket Keeper Dismissals all are considered for Result.",
            "danger": true
          },
          {
            "text": "Example : If a match started as 20 Overs game after rain Overs reduced to 16 Overs match, in that match Maximum 6s reached means that Value considered for Result",
            "danger": true
          },
          {
            "text": "Super over will not be included.",
            "danger": true
          },
          {
            "text": "Ashes Special 2025-2026",
            "danger": true
          },
          {
            "text": "If Ashes fixture of 5 Matches gets Reduced Due to Any Reason, Then all the Special Fancies will be Voided (Match abandoned due to rain/bad light will not be considered in this)",
            "danger": true
          },
          {
            "text": "Management decision will be final",
            "danger": true
          },
          {
            "text": "Total 1st Over Runs of Ashes: Total of All Five Match 1st Over Runs will be Counted in this Event. Match 1st Innings Only Valid. If Aus First Batting Start Means Aus 1st Over Only Considered. In Case Match Abandoned Means 3 Runs Average will be Given.",
            "danger": false
          },
          {
            "text": "Total 1st 5 Over Runs of Ashes: Total of All Five Match 1st 5 Over Runs will be Counted in this Event. Match 1st Innings Only Valid. If Aus First Batting Start Means Aus 1st 5 Over Only Considered. In Case Match Abandoned Means 17 Runs Average will be Given.",
            "danger": false
          },
          {
            "text": "Total 1st 10 Over Runs of Ashes : Total of All Five Match 1st 10 Over Runs will be Counted in this Event. Match 1st Innings Only Valid. If Aus First Batting Start Means Aus 1st 10 Over Only Considered. In Case Match Abandoned Means 35 Runs Average will be Given.",
            "danger": false
          },
          {
            "text": "Highest Single Innings Score of Ashes: Maximum Runs Scored by any Team in their any Single Innings",
            "danger": false
          },
          {
            "text": "Highest Total Runs of Ashes: Maximum Runs Scored in any Single Match of Series. All Innings Counted.",
            "danger": false
          },
          {
            "text": "High Partnership Runs of Ashes: Highest Partnership Runs Scored by Players in any Innings",
            "danger": false
          },
          {
            "text": "High Partnership Balls of Ashes: Highest Partnership Balls Faced by Players in any Innings",
            "danger": false
          },
          {
            "text": "Top Batsman Runs in an Inn of Ashes: Maximum Runs Scored by a Batsman in Single Innings",
            "danger": false
          },
          {
            "text": "Highest Run Scorer Runs of Ashes: Maximum Runs Scored by Any Individual Batsman in Full Tournament",
            "danger": false
          },
          {
            "text": "Highest Wicket Taker Wickets of Ashes: Maximum Wickets Taken by Any Individual Bowler in Full Tournament",
            "danger": false
          },
          {
            "text": "Events Based in Total Counts of Full Match All Valid Only Match will be 300 Overs has been Played with Draw or Match has been won by Any team. Otherwise Mentioned Average will be Given. (Total Events Considered for Full Ashes Tournament)",
            "danger": true
          },
          {
            "text": "Total 4s of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 115 Fours will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Wkts of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 34 Wickets will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Wides of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 9 Wides will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Noballs of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 14 Noballs will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Extras of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 55 Extras will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Caught Outs of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 22 Caught outs will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Bowled of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 6 Bowled will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total LBW of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 4 LBW will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Runout of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 1 Runout will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total 30s of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 5 30s will be Counted as Average. 30 to 49 Runs Only Counted as 30s. If a Player Crossed 50 Means not Counted in this",
            "danger": false
          },
          {
            "text": "Total 50s of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 5 50s will be Counted as Average. 50 to 99 Runs Only Counted as 50s. If a Player Crossed 100 Means not Counted in this.",
            "danger": false
          },
          {
            "text": "Total 100s of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 2 100s will be Counted as Average. 100 Above all Scores Counted in this.",
            "danger": false
          },
          {
            "text": "Total 150s of Ashes: 150 above all Score Counted in this",
            "danger": false
          },
          {
            "text": "Total Maidens of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 55 Maidens will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Duckouts of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 4 Duckouts will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Single Digit Scorers of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 12 Single Digit Scorers will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Double Digit Scorers of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 20 Double Digit Scorers will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Wicketkeeper's Dismissal in Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 8 Wicketkeeper's Dismissal will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Players facing 50plus Balls in Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 13 Players 50plus Balls will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Four Hitters of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 28 Four Hitters will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Wicket Takers of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 16 Wicket Takers will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Total Bowlers Giving 100 Plus Runs of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 2 Bowler 100plus run will be Counted as Average.",
            "danger": false
          },
          {
            "text": "Highest Extras in Individual Match of Ashes : Maximum Extras Coming in any Full Test Match. All Innings Extras are Counted. Maximum Extras Coming in any Full Test Match. All Innings Extras are Counted",
            "danger": false
          },
          {
            "text": "Highest Caught Outs in Individual Match of Ashes : Maximum Caught Outs Coming in any Full Test Match. All Innings Caught Outs are Counted",
            "danger": false
          },
          {
            "text": "Highest Bowled in Individual Match of Ashes : Maximum Bowled Coming in any Full Test Match. All Innings Bowled are Counted",
            "danger": false
          },
          {
            "text": "Highest LBW in Individual Match of Ashes : Maximum LBW Coming in any Full Test Match. All Innings LBW are Counted",
            "danger": false
          },
          {
            "text": "Highest Runout in Individual Match of Ashes : Maximum Runout Coming in any Full Test Match. All Innings Runout are Counted",
            "danger": false
          },
          {
            "text": "Highest 30s in Individual Match of Ashes : Maximum 30s Coming in any Full Test Match. All Innings 30s are Counted",
            "danger": false
          },
          {
            "text": "Highest 50s in Individual Match of Ashes : Maximum 50s Coming in any Full Test Match. All Innings 50s are Counted",
            "danger": false
          },
          {
            "text": "Highest 100s in Individual Match of Ashes : Maximum 100s Coming in any Full Test Match. All Innings 100s are Counted",
            "danger": false
          },
          {
            "text": "Highest Maidens in Individual Match of Ashes : Maximum Maidens Coming in any Full Test Match. All Innings Maidens are Counted",
            "danger": false
          },
          {
            "text": "Highest Duckouts in Individual Match of Ashes : Maximum Duckouts Coming in any Full Test Match. All Innings Duckouts are Counted",
            "danger": false
          },
          {
            "text": "Highest Single Digit Scorers in Individual Match of Ashes : Maximum Single Digit Scorers Coming in any Full Test Match. All Innings Single Digit Scorers are Counted",
            "danger": false
          },
          {
            "text": "Highest Double Digit Scorers in Individual Match of Ashes : Maximum Double Digit Scorers Coming in any Full Test Match. All Innings Double Digit Scorers are Counted",
            "danger": false
          },
          {
            "text": "Highest Wicketkeeper's Dismissal in Ashes : Maximum Wicketkeeper's Dismissal Coming in any Full Test Match. All Innings Wicketkeeper's Dismissal are Counted. Caught Outs and Stumpings only Considered in this Event.",
            "danger": false
          },
          {
            "text": "Highest Players facing 50plus Balls in Ashes : Maximum Player Facing 50+ Balls Coming in any Full Test Match. All Innings Player Facing 50+ Balls are Counted",
            "danger": false
          },
          {
            "text": "Highest Four Hitters in Individual Match of Ashes : Maximum Four Hitters Coming in any Full Test Match. All Innings Four Hitters are Counted",
            "danger": false
          },
          {
            "text": "Highest Wicket Takers in Individual Match of Ashes : Maximum Wicket Takers Coming in any Full Test Match. All Innings Wicket Takers are Counted",
            "danger": false
          },
          {
            "text": "Highest Bowlers Giving 100 Plus Runs in Individual Match of Ashes : Maximum Bowler Giving 100+ Runs Coming in any Full Test Match. All Innings Bowler Giving 100+ Runs are Counted",
            "danger": false
          },
          {
            "text": "Highest Scoring Over Runs in Ashes : Maximum Runs Scored in Single Over of any Match",
            "danger": false
          },
          {
            "text": "Most Balls faced by a Batsman in an Inn of Ashes : Maximum Balls Faced by a Batsman in Single Innings of any Match",
            "danger": false
          },
          {
            "text": "Most 4s Hitted by a Batsman in Ashes : Maximum 4s Hitted by Any Individual Batsman in Full Tournament",
            "danger": false
          },
          {
            "text": "Most 50s Scored by a Batsman in Ashes : Maximum 50s Scored by Any Individual Batsman in Full Tournament",
            "danger": false
          },
          {
            "text": "Most 4s by a Batsman in Inn of Ashes Maximum Fours Hitted by Any Batsman in Single Innings",
            "danger": false
          },
          {
            "text": "Most Runs given by a Bowler in an Inn of Ashes : Maximum Runs Conceded by any Bowler in Single Innings",
            "danger": false
          },
          {
            "text": "Most Wickets Taken by a Bowler in an Inn of Ashes : Maximum Wickets Taken by Any Bowler in Single Innings",
            "danger": false
          },
          {
            "text": "Most Wickets Taken by a Bowler in a Match of Ashes : Maximum Wickets Taken by Any Bowler in Full Match. Both Innings Wickets Counted.",
            "danger": false
          },
          {
            "text": "Highest Match 1st Over in a Match of Ashes : Maximum Runs Scored in Match 1st Over. Match 1st Innings Only Valid. If Aus First Batting Start Means Aus 1st Over Only Considered.",
            "danger": false
          },
          {
            "text": "Highest Match 1st 5 Over in a Match of Ashes : Maximum Runs Scored in Match 1st 5 Over. Match 1st Innings Only Valid. If Aus First Batting Start Means Aus 1st 5 Over Only Considered.",
            "danger": false
          },
          {
            "text": "Highest Match 1st 10 Over in a Match of Ashes : Maximum Runs Scored in Match 1st 10 Over. Match 1st Innings Only Valid. If Aus First Batting Start Means Aus 1st 10 Over Only Considered.",
            "danger": false
          },
          {
            "text": "Highest 4s in Individual Match of Ashes : Maximum Fours Hitted in any Full Test Match. All Innings Fours are Counted",
            "danger": false
          },
          {
            "text": "Highest Wides in Individual Match of Ashes : Maximum Wides Coming in any Full Test Match. All Innings Wides are Counted",
            "danger": false
          },
          {
            "text": "Highest Noballs in Individual Match of Ashes : Maximum Noballs coming in any Full Test Match. All Innings Noballs are Counted",
            "danger": false
          },
          {
            "text": "BBL SPECIAL 2025-2026",
            "danger": true
          },
          {
            "text": "If BBL fixture of 44 matches gets reduced due to any reason, then all the special fancies will be voided (Match abandoned due to rain/bad light will not be considered in this)",
            "danger": true
          },
          {
            "text": "At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid, similarly if the tournament gets canceled due to any reason the previously given result will be considered valid",
            "danger": true
          },
          {
            "text": "Highest Innings run - Only First Innings is Valid",
            "danger": false
          },
          {
            "text": "Lowest Innings run - Only First Innings is Valid",
            "danger": false
          },
          {
            "text": "Highest Total Runs in Single Match of BBL: Maximum Runs Scored by 2 Teams in Single Match.",
            "danger": false
          },
          {
            "text": "Largest Margin Win by Runs of BBL : Maximum Runs Margin Win by Any Team. Example : PS 210 in 1st Inn and SS 150 in 2nd Inn Means PS Win by 60 run Margin.",
            "danger": false
          },
          {
            "text": "Highest Partnership Runs in BBL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "Highest Partnership Balls in BBL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "Highest Partnership Boundaries in BBL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "In fastest fifty always the first 50 runs will be considered, for example of S Smith scores 1st fifty in 17 balls and scores 100 in next 14 balls, fastest 50 will be given based on the balls for the 1st fifty runs",
            "danger": false
          },
          {
            "text": "Highest Run Scorer Runs : Total Runs Scored by An Individual Batsman in Full Tournament (BBL GOLDEN BAT)",
            "danger": false
          },
          {
            "text": "Highest Wicket Taker Wickets: Total Wickets Taken by a Bowler in Full Tournament (BBL GOLDEN ARM)",
            "danger": false
          },
          {
            "text": "How Many time 5 or More Wickets taken by Bowlers : Number of time 5 or More Wickets taken by Bowlers. In Case Same Bowler 2 time 5 or More Wickets taken means Result Counted as 2.",
            "danger": false
          },
          {
            "text": "Total 1st Over Runs : Average 6 Runs will be given in case match abandoned or over reduced. 1st Inn Match 1st Over Runs Only Considered",
            "danger": false
          },
          {
            "text": "Total 4's: Average 26 Fours will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total 6's: Average 12 Sixes will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Boundaries: Average 38 Boundaries will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Wickets - Average will 13 Wickets be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Wides - Average 8 Wides will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Extras - Average 16 Extras will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Caught outs: Average 9 Caught out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Bowled:- Average 2 Bowled out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total LBW:- Average 1 LBW will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Run out:- Average 1 Run out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total 30's: Average 3 Thirties will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total 50's: Average 1 Fifties will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Duckouts in BBL : Average 1 Duckout will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Single Digit Scorers in BBL : Average 6 Single Digit Scorers will be given in case match abandoned or over reduced.Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
            "danger": false
          },
          {
            "text": "Total Double Digit Scorers in BBL : Average 9 Double Digit Scorers will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Players Facing 25 plus Balls in BBL : Average 3 Players will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Impact Overs in BBL : Average 14 Impact Over will be given in case match abandoned or over reduced.Number of over’s scored 10 runs and above. If a team all out or Match Resulted in 15.2 then considered as 16 over.",
            "danger": false
          },
          {
            "text": "Total No Boundaries Overs in BBL : Average 14 No Boundaries Over will be given in case match abandoned or over reduced.If Match Resulted in 2nd Inn 17 Overs Means How Many Overs Boundaries not Came in that 37 Overs Only Considered.Balance 3 Overs not Considered in this.",
            "danger": false
          },
          {
            "text": "Total Four Hitters in BBL : Average 9 Four Hitter will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Six Hitters in BBL : Average 6 Six Hitter will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Wicket Takers in BBL : Average 7 Wicket Taker will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Bowler Giving 30plus Runs in BBL : Average 5 Bowlers will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Highest Scoring Over Runs in BBL: Total of Every Match Highest Scoring Over Runs. Average 20 Runs will be given in case match abandoned or over reduced.",
            "danger": false
          },
          {
            "text": "Highest Match 1st Over Run of BBL : Only First Innings is Valid.",
            "danger": false
          },
          {
            "text": "Highest 1st 6 over run: Only First Innings is Valid.Will not consider if over reduce before completion 6 over.",
            "danger": false
          },
          {
            "text": "Highest 1st 10 over run : Only First Innings is Valid.Will not consider if over reduce before completion 10 over.",
            "danger": false
          },
          {
            "text": "Highest 4s,6s,Boundaries,Wickets,Wides,Extras,Caught Outs,Bowled,Lbw, Runouts,30s,50s, Duckouts,Single Digit Scorers, Double Digit Scorers,Players 25+ balls, Impact Overs, Noboundary Overs,Four Hitter,Six Hitter,Wicket Takers and Bowler 30+ Runs in individual match: All Both Innings are Counted.",
            "danger": false
          },
          {
            "text": "Highest Scoring Over Runs in BBL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "Most Balls Faced By a Batsman of BBL : Maximum balls Faced by an Individual Batsman in the Single Match.",
            "danger": false
          },
          {
            "text": "Most 4's by a Batsman in an Inn of BBL : Maximum 4s Hitted by an Individual Batsman in any Single Match",
            "danger": false
          },
          {
            "text": "Most 6's by a Batsman in an Inn of BBL : Maximum 6s Hitted by an Individual Batsman in any Single Match",
            "danger": false
          },
          {
            "text": "Most Boundaries Given by a Bowler in an Inn of BBL : Maximum Boundaries Conceded By Single Bowler in His 4 Overs.",
            "danger": false
          },
          {
            "text": "Most Dotballs By a Bowler in an Inn of BBL : Maximum Dotballs By Single Bowler in His 4 Overs.",
            "danger": false
          },
          {
            "text": "Most Runs Given by Bowler in an Inning of BBL : Maximum Runs conceded by a individual Bowler in an Innings.",
            "danger": false
          },
          {
            "text": "Most 4s hitted by a Batsman of BBL : Maximum Fours Hitted by Single Batsman in Full Tournament.",
            "danger": false
          },
          {
            "text": "Most 6s hitted by a Batsman of BBL : Maximum Sixes Hitted by Single Batsman in Full Tournament.",
            "danger": false
          },
          {
            "text": "Most 50s Scored by a Batsman of BBL : Maximum 50s Scored by Single Batsman in Full Tournament.",
            "danger": false
          },
          {
            "text": "Most 4s,6s,Wide,Extras,Caught Outs,Bowled,LBW,Single Digit Scorers, Double Digit Scorers, Four Hitters,Six Hitters and Wicket Takers in an Innings Of the Match : Considered For Maximum Reached Any Innings.All Both Innings Considered as Valid",
            "danger": false
          },
          {
            "text": "Super over will not be included",
            "danger": false
          },
          {
            "text": "If the match starts Over Reduced Game or 20 Over Game, after the balls are reduced due to rain interrupting means comparison Events like Highest 4s,6s, boundaries,30s,50s, Wickets,Wides,Extras,Caughtouts,Bowled,Lbw,Runout,Duckout,Single Digit Scorers, Double Digit Scorers and Most 4s,6s,boundaries,30s,50s, Caught outs,Bowled,Duckout, wicket Keeper Dismissals all are considered for Result.",
            "danger": true
          },
          {
            "text": "Example : If a match started as 20 Overs game after rain Overs reduced to 16 Overs match, in that match Maximum 6s reached means that Value considered for Result",
            "danger": true
          },
          {
            "text": "Indoor Cricket T10 League",
            "danger": true
          },
          {
            "text": "9 Players squad with 7 players a side Over Arm Box Cricket Championship",
            "danger": false
          },
          {
            "text": "Scoring Rules :",
            "danger": true
          },
          {
            "text": "Hitting the ball in Zone A (the front net, i.e., the net behind the wicket keeper) won't get you any bonus runs.",
            "danger": false
          },
          {
            "text": "If the ball hits the net in Zone B (side nets between the striker's end and halfway down the pitch), you get 1 bonus run.",
            "danger": false
          },
          {
            "text": "If the ball hits the net in Zone C (side nets between the bowler's end and halfway), you score 2 bonus runs.",
            "danger": false
          },
          {
            "text": "Hitting the ball in Zone D (the back net, i.e., the net behind the bowler) allows you to score 4 or 6 bonus runs depending on how the ball hits the back net. If the ball hits the net after bouncing, you get 4 bonus runs. If the ball hits the net without bouncing on the ground, you score 6 bonus runs.",
            "danger": false
          },
          {
            "text": "If the ball hits Zone B or C onto Zone D, you score 3 bonus runs.",
            "danger": false
          },
          {
            "text": "Remember that at least one physical run must be taken for any bonus runs to be scored. Whatever bonus runs you get will be added to the physical runs. For example, if you strike the ball into the front net for 1 bonus run and take 2 physical runs, you score a total of 3 runs off the ball.",
            "danger": false
          },
          {
            "text": "Game Format :",
            "danger": true
          },
          {
            "text": "10 over a-side innings",
            "danger": false
          },
          {
            "text": "Power Play for the 1st 3 overs. Only 1 player allowed beyond the Inner box marking. After the end of power play over, only 2 players can be outside the Inner Box.",
            "danger": false
          },
          {
            "text": "No Ball & Wide balls as per normal cricketing rules.",
            "danger": false
          },
          {
            "text": "If the ball touches the upper net and if any player catches the ball, the batsman is considered out.",
            "danger": false
          },
          {
            "text": "If the Ball Touches the Upper Net and lands safely on the field, then the batsman have to take a physical run if they want, if no physical run is taken there will be no runs.",
            "danger": false
          },
          {
            "text": "Zone A shall concede 0 runs.",
            "danger": false
          },
          {
            "text": "If the player hits the net after the middle line (Zone C) its 2 bonus runs. (only taken into consideration if the players take a physical run)",
            "danger": false
          },
          {
            "text": "If the player hits the net before the middle line (Zone B) its 1 bonus run. (only taken into consideration if the players take a physical run)",
            "danger": false
          },
          {
            "text": "If the ball goes straight to the boundary (Zone D) without a bounce, it’s a SIX.",
            "danger": false
          },
          {
            "text": "If the ball bounces and goes to the boundary (Zone D) it’s a FOUR",
            "danger": false
          },
          {
            "text": "If the ball hits the upper net and goes straight to the boundary (Zone D) it’s a 6.",
            "danger": false
          },
          {
            "text": "If the ball hits the upper net and bounces and goes straight to the boundary (Zone D) it’s a 4.",
            "danger": false
          },
          {
            "text": "Note: Bonus Runs are only applied if the ball hits or touches the Side Nets of that particular zone (B&C) and taken into consideration if the players take a physical Run.",
            "danger": false
          },
          {
            "text": "The bowler is not allowed to touch the front line or the side line of the Crease, in case they do so it will be counted as a no ball and 2 runs will be given to the batting team and the ball will not be counted.",
            "danger": false
          },
          {
            "text": "If a bowler bowls a no or a wide ball, the delivery will not be counted and each wide or no ball will be given 2 runs to the batting team total.",
            "danger": false
          },
          {
            "text": "If the batsman is a right hander and if the ball goes out of the white wide line it will be given as a wide ball & if the ball is going leg side and is inside the Leg Side line the ball is counted.",
            "danger": false
          },
          {
            "text": "Dismissals in Indoor Cricket are as followed: Bowled, Run Out, Catch Out, Stumping and Handling the Ball.",
            "danger": false
          },
          {
            "text": "If the bowler is bowling directly above waist and one bounce above shoulder level it is counted as a no ball, but the batter has to play the ball from the crease, in case the batter is outside the crease and plays the ball it will be termed as a good ball.",
            "danger": false
          },
          {
            "text": "Incomplete action or throwing the ball to the stump will be termed as a no ball and 2 runs will be given to the batting team.",
            "danger": false
          },
          {
            "text": "If the batsman does not hit the ball after it is bowled it is considered as a Dot Ball, the batsman gets 0 runs.",
            "danger": false
          },
          {
            "text": "If the batsman hits the ball and the fielders or the wicket-keeper catch it without it touching the floor, the batsman will be dismissed as Catch Out.",
            "danger": false
          },
          {
            "text": "If the ball touches a fielder and then hits the nets (zones), the bonus runs will be counted, if the physical runs are taken by the batter.",
            "danger": false
          },
          {
            "text": "No runs for overthrow.",
            "danger": false
          },
          {
            "text": "If the ball is caught directly after touching the zones (B/C), it will be treated as NOT OUT and bonus runs are applicable if physical run is taken.",
            "danger": false
          },
          {
            "text": "If the ball touches the bonus run zones and the fielder accomplishes a run out, the batter will be OUT and no bonus runs will be counted. Physical run will be counted if 1 run is taken and run out happens during the second run.",
            "danger": false
          },
          {
            "text": "When a batter gets out, the next player coming in will take the strike.",
            "danger": false
          },
          {
            "text": "Run out will ONLY be at the batter’s end.",
            "danger": false
          },
          {
            "text": "When 6 wickets of a team fall, the last batter will be allowed to bat. The team will send a runner at non-striker’s end. After every physical run taken, the last batsman will have to go back to strike to face the next ball. Run out for the runner will mean dismissal for the last batsman.",
            "danger": false
          }
        ]
      },
      {
        "name": "fancy1",
        "rules": [
          {
            "text": "1. Odd/Even Rules. (W.e.f 5th January 2024)",
            "danger": true
          },
          {
            "text": "1.3 In case of all out or the target chased down, particular session will be considered as a completed session.",
            "danger": false
          },
          {
            "text": "For Example : IN ODI - IND got all out at 12.3 over then 15 over session will be considered as a completed session or AUS get chase down the target in 12.3 over then 15 over session will be considered as a completed session.",
            "danger": false
          },
          {
            "text": "IN TEST - IND got all out at 12.3 over then 20 over session will be considered as a completed session or AUS get chase down the target in 12.3 over then 20 over session will be considered as a completed session.",
            "danger": false
          },
          {
            "text": "IN T10/T20 - IND got all out at 8.3 over then 9 over session will be considered as a completed session or AUS get chase down the target in 8.3 over then 9 over session will be considered as a completed session.",
            "danger": false
          },
          {
            "text": "1.2 All bets regarding Odd/Even sessions will be deleted if the particular session is incomplete.",
            "danger": false
          },
          {
            "text": "1.1 Advance events will be valid if over reduced before match start. For Ex: - In T20, If over reduced to 16 over so up to 16 over valid remaining over will be deleted.",
            "danger": false
          },
          {
            "text": "1.5 Innings run Odd/Even session will be valid if over reduced due to weather condition.",
            "danger": false
          },
          {
            "text": "1.4 All bets regarding to ODD/EVEN player/partnership are valid if one legal delivery is being played, else the bets will be deleted. Player odd/even all advance bets will be valid if one legal delivery is being played in match otherwise voided.",
            "danger": false
          },
          {
            "text": "1.6 In any circumstances management decision will be final.",
            "danger": false
          },
          {
            "text": "1.7 Penalty runs will be counted in all Events. (This rule applicable from 20th March 2024)",
            "danger": false
          },
          {
            "text": "2 Top batsman rules:-",
            "danger": true
          },
          {
            "text": "2.1 If any player does not come as per playing eleven then all bets will be get deleted for the particular player.",
            "danger": true
          },
          {
            "text": "2.2 two players done the same run in a single match (M Agarwal 30 runs and A Rayudu 30 runs, whole inning top batsmen score also 30 run) then both player settlement to be get done 50 percent (50% , 50%)rate on their original value which given by our exchange.",
            "danger": false
          },
          {
            "text": "Suppose we have opened value of M Agarwal 3.75 back and customer place bets on 10000 @ 3.75 rates and A Rayudu 3.0 back and customer place bets on 10000 @ 3.0 rates.",
            "danger": false
          },
          {
            "text": "Whole inning result announces 30 run by both player then",
            "danger": false
          },
          {
            "text": "Rule of top batsman:-if you bet on M Agarwal you will be get half amount of this rate (10000*3.75/2=18750 you will get)",
            "danger": true
          },
          {
            "text": "Rule of top batsman:-if you bet on A Rayudu you will be get half amount of this rate (10000*3.00/2=15000 you will get)",
            "danger": true
          },
          {
            "text": "Top batsman only 1st inning valid.",
            "danger": false
          },
          {
            "text": "For one day 50 over and for t-20 match 20 over must be played for top batsmen otherwise all bets will be deleted.",
            "danger": false
          },
          {
            "text": "Man of the Match Rules",
            "danger": true
          },
          {
            "text": "1. All bets will be deleted in case the match is abandoned or over reduced.",
            "danger": false
          },
          {
            "text": "2. All bets will be deleted if the mentioned player is not included in playing 11.",
            "danger": false
          },
          {
            "text": "3. In case Man of the Match is shared between two players then Dead heat rule will be applicable, For example K Perera and T Iqbal shares the Man of the Match, then the settlement will be done 50% of the rates accordingly.",
            "danger": false
          },
          {
            "text": "4. Rules similar to our Top Batsman rules.",
            "danger": false
          },
          {
            "text": "Maximum Sixes by Team",
            "danger": true
          },
          {
            "text": "1. All bets will be deleted if match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "2. All bets will be deleted if both the teams hits same number of sixes.",
            "danger": false
          },
          {
            "text": "3. Super over will not be considered.",
            "danger": false
          },
          {
            "text": "Maximum 6 or 10 over runs",
            "danger": true
          },
          {
            "text": "1. All bets will be deleted if match abandoned or over reduced.",
            "danger": false
          },
          {
            "text": "2. All the bets will be deleted if both the teams score is same (Runs scored in 6 or 10 overs)",
            "danger": false
          },
          {
            "text": "3. 6 overs for T20 and 10 overs for ODI",
            "danger": false
          },
          {
            "text": "4. Both the innings are valid.",
            "danger": false
          },
          {
            "text": "5. This fancy will be valid for 1st 6 overs of both innings for T20 and 1st 10 overs of both innings for ODI",
            "danger": false
          },
          {
            "text": "Batsman Match",
            "danger": true
          },
          {
            "text": "Batsman Match:- Bets for Favourite batsman from the two batsman matched.",
            "danger": false
          },
          {
            "text": "All bets will be deleted if any one of the mentioned player is not included in playing 11.",
            "danger": false
          },
          {
            "text": "All bets will be deleted unless one ball being played by both the mentioned players.",
            "danger": false
          },
          {
            "text": "All bets will be deleted if over reduced or Match abandoned.",
            "danger": false
          },
          {
            "text": "All bets will be deleted if both the player scored same run. For example H Amla and J Bairstow are the batsman matched, H Amla and J Bairstow both scored 38 runs then all bets will be deleted.",
            "danger": false
          },
          {
            "text": "Both innings will be valid",
            "danger": false
          },
          {
            "text": "Opening Pair",
            "danger": true
          },
          {
            "text": "1. Bets for Favourite opening pair from the two mentioned opening pair.",
            "danger": false
          },
          {
            "text": "2. Runs made by both the opening player will be added. For example:- J Roy scored 20 runs and J Bairstow scored 30 runs result will be 50 runs.",
            "danger": false
          },
          {
            "text": "3. Highest run made by the pair will be declared as winner. For example: Opening pair ENG total is 70 runs and Opening pair SA is 90 runs, then SA 90 runs will be declared as winner.",
            "danger": false
          },
          {
            "text": "Both innings will be valid",
            "danger": false
          },
          {
            "text": "Our exchange Special",
            "danger": true
          },
          {
            "text": "All bets will be deleted if the mentioned player is not included in playing 11.",
            "danger": false
          },
          {
            "text": "All bets will be deleted if match abandoned or over reduced.",
            "danger": false
          },
          {
            "text": "Both innings will be valid",
            "danger": false
          },
          {
            "text": "Direction of First Boundary",
            "danger": true
          },
          {
            "text": "All bets will be deleted if the mentioned batsman is not included in playing 11.",
            "danger": false
          },
          {
            "text": "All bets will be deleted if match abandoned or over reduced.",
            "danger": false
          },
          {
            "text": "The boundary hit through off side of the stump will be considered as off side four.",
            "danger": false
          },
          {
            "text": "The boundary hit through leg side of the stump will be considered as leg side four.",
            "danger": false
          },
          {
            "text": "Boundaries through extras (byes,leg byes,wide,overthrow) will not be considered as valid.",
            "danger": false
          },
          {
            "text": "Only 1st Inning will be considered",
            "danger": false
          },
          {
            "text": "Fifty & Century by Batsman",
            "danger": true
          },
          {
            "text": "All bets will be deleted if match abandoned or over reduced.",
            "danger": false
          },
          {
            "text": "All bets will be deleted if the mentioned batsman is not included in playing 11.",
            "danger": false
          },
          {
            "text": "All bets will be deleted unless the batsman faces one legal ball.",
            "danger": false
          },
          {
            "text": "Both Innings will be valid.",
            "danger": false
          },
          {
            "text": "1st over Fancy",
            "danger": true
          },
          {
            "text": "Boundaries through extras (byes,leg byes,wide,overthrow) will not be considered.",
            "danger": false
          },
          {
            "text": "Only 1st inning will be valid",
            "danger": false
          },
          {
            "text": "Odd Even Fancy",
            "danger": true
          },
          {
            "text": "Incompleted games will be deleted. Over reduced or abandoned all bets will be deleted.",
            "danger": false
          },
          {
            "text": "For example:-275 run SL bhav must be played 50 over if rain comes or any condition otherwise 275 run SL bets will be deleted.",
            "danger": true
          },
          {
            "text": "Next Man out",
            "danger": true
          },
          {
            "text": "Next man out fancy advance & in regular. Both inning will be valid. If any player does not come in opening then all bets will be deleted. If over reduced or abandoned then all bets will be deleted.",
            "danger": false
          },
          {
            "text": "Caught out",
            "danger": true
          },
          {
            "text": "Caught out fancy in advance & in regular. Both inning will be valid. If over reduced or match abandoned then all bets will be deleted.",
            "danger": false
          },
          {
            "text": "Wkt & All out Fancy",
            "danger": true
          },
          {
            "text": "5 wkt in 10 over & All out in 20 over fancy is valid for both inning. If match abandoned or over reduced all bets will be deleted.",
            "danger": false
          },
          {
            "text": "Test Match: Game Completed Fancy",
            "danger": true
          },
          {
            "text": "1. This is the fancy for match to be won/ completed in which day & session (Completed: Game has to be completed)",
            "danger": false
          },
          {
            "text": "2. If match drawn then all the sessions will be considered as lost.",
            "danger": false
          },
          {
            "text": "Meter Fancy",
            "danger": true
          },
          {
            "text": "In case match abandoned or over reduced mid point rule will be applicable",
            "danger": false
          },
          {
            "text": "For example: If Dhoni meter is 75 / 77 and the match abandoned or over reduced, then the result will be 76",
            "danger": false
          },
          {
            "text": "In case of single difference result will be given for the higher rate of the final rate (eg 53/54) and match gets abandoned then the result will be given as 54",
            "danger": false
          },
          {
            "text": "Midpoint rule is applicable for test match also. However for lambi meter/ inning meter 70 overs has to be played only then the same will be considered as valid",
            "danger": false
          },
          {
            "text": "Maximum Boundaries:-",
            "danger": true
          },
          {
            "text": "If the number of fours or sixes of both the team is equal, then all bets of the respective event will get voided",
            "danger": false
          },
          {
            "text": "Khado:- Test",
            "danger": true
          },
          {
            "text": "Minimum 70 over has to be played by the particular team only then the Khado of the team will be considered as valid, else the same will be voided",
            "danger": false
          },
          {
            "text": "Lunch Favourite",
            "danger": true
          },
          {
            "text": "1. The team which is favourite at lunch will be considered as lunch favourite or the team which is favourite after first inning last ball will be considered as lunch favourite in our exchange.",
            "danger": true
          },
          {
            "text": "2. In any circumstances management decision will be final.",
            "danger": true
          },
          {
            "text": "3. In case of tie in T20 or one day in lunch favourite game , all bets will be deleted in our exchange.",
            "danger": true
          },
          {
            "text": "4. In case overs are reduced in a match, the team which favourite at lunch will be considered as lunch favourite.",
            "danger": true
          },
          {
            "text": "4.1 For example :- if match is reduced to 18 over per side in t20 or Oneday then after 18 over the team which is favourite at lunch will be considered as lunch favourite.",
            "danger": false
          },
          {
            "text": "5. In case of weather, 1st innings match overs are reduced and direct target is given to team which will bat in 2nd inning then lunch favourite will be considered after target is given at lunch.",
            "danger": true
          },
          {
            "text": "5.1 For example :- in T20 match rain comes at 14 over and match is interrupted due to rain and direct target is given to 2nd batting team, then team which is favourite in match odds after target is given in match, will be considered as lunch favourite.",
            "danger": false
          },
          {
            "text": "Common Market:-",
            "danger": true
          },
          {
            "text": "In future, due to any circumstances if any Match/Series/League is postponed or rescheduled to another date, all related bets will be voided.",
            "danger": false
          },
          {
            "text": "Due to any reasons company has rights to take final decisions.",
            "danger": false
          },
          {
            "text": "Hundred Men's",
            "danger": true
          },
          {
            "text": "5 Consecutive Sixes in 5 Balls Given by a Bowler : Any Single Bowler Conceding 5 Consecutive Sixes in his 5 Consecutive Balls If 10 Balls Consecutively putting means Any 5 Balls Receive Consecutively 5 Sixes Received Means Considered as valid.",
            "danger": false
          },
          {
            "text": "Example : 41 to 45 Balls Narine Concede 5 Sixes means considered as Result. 41 to 50 Narine Over 43 to 47 Balls Concede 5 Sixes Means Valid",
            "danger": false
          },
          {
            "text": "5 Consecutive Fours in 5 Balls Given by a Bowler : Any Single Bowler Conceding 5 Consecutive Fours in his 5 Consecutive Balls.",
            "danger": false
          },
          {
            "text": "Opening Two Player Comparison Events :",
            "danger": true
          },
          {
            "text": "If Mentioned Both Player Scored Same Score Means Events will be Deleted.",
            "danger": false
          },
          {
            "text": "If Mentioned Player not Played as the Opener of Match means Particular Event will be Deleted.",
            "danger": false
          },
          {
            "text": "Mentioned Both Batsman Facing Single Legal Delivery Means Considered For Result",
            "danger": false
          },
          {
            "text": "Example : Match Cancelled after 2.4 Over means If Both Player Facing One Legal Delivery Means Considered for Result. While Playing 2nd Inn Both Player Facing One Legal Delivery Means All Events Considered For Result. If Any Player not Facing Single Delivery Means Particular Player Based Events All Deleted.",
            "danger": false
          }
        ]
      },
      {
        "name": "cricket casino",
        "rules": [
          {
            "text": "1. Completed game is valid , In case match abandoned due to rain particular game will be deleted.",
            "danger": true
          },
          {
            "text": "1.2 If a team got all out in 17 over although Innings Lambi run valid. (w.e.f. 15th June 2024)",
            "danger": false
          },
          {
            "text": "1.3 In case of all out or the target chased down, particular session will be considered as a completed session (For Example : IND got all out at 12.3 over then 15 over session will be considered as a completed session or AUS get chase down the target in 12.3 over then 15 over session will be considered as a completed session)",
            "danger": false
          },
          {
            "text": "1.1 If over are reduced to 17 over instead of 20 due to rain or weather conditions, Innings Lambi run valid. (w.e.f. 15th June 2024)",
            "danger": false
          },
          {
            "text": "2. Penalty runs will be counted in our exchange. (This rule applicable from 15th June 2024)",
            "danger": true
          },
          {
            "text": "3. In any circumstances management decision will be final.",
            "danger": true
          },
          {
            "text": "4. The last digit of run in all game will be valid in our exchange.",
            "danger": true
          },
          {
            "text": "5. Single last digit game :-",
            "danger": true
          },
          {
            "text": "5.1 For example:- 6 over run Ind : 47 run , so the result will be given as 7 for single last digit game in our exchange.",
            "danger": false
          },
          {
            "text": "6. Double last digit game :-",
            "danger": true
          },
          {
            "text": "6.1 For example:- 6 over run & 10 over run Ind : 45 run & 83 run respectively , so the result will be given as 53 for double last digit game in our exchange.",
            "danger": false
          },
          {
            "text": "7. Triple last digit game :-",
            "danger": true
          },
          {
            "text": "7.1 For example:- 6 over run, 10 over run & 15 over run Ind : 43 run ,80 run and 125 respectively so the result will be given as 305 for triple last digit game in our exchange.",
            "danger": false
          },
          {
            "text": "7.2 For example:- 6 over run, 10 over run & Lambi run Ind : 43 run ,80 run and 187 respectively so the result will be given as 307 for triple last digit game in our exchange.",
            "danger": false
          }
        ]
      },
      {
        "name": "match",
        "rules": [
          {
            "text": "IPL SPECIAL 2026",
            "danger": false
          },
          {
            "text": "If IPL Fixture of 74 Matches Gets Reduced Due to any Reason, then all the Special Fancies will be Voided (Match Abandoned Due to Rain/Bad Light will not be Considered in this)",
            "danger": true
          },
          {
            "text": "At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid, similarly if the tournament gets canceled due to any reason the previously given result will be considered valid",
            "danger": true
          },
          {
            "text": "Management decision will be final",
            "danger": true
          },
          {
            "text": "Highest Innings run(1st Inn) - Only First Innings is Valid",
            "danger": false
          },
          {
            "text": "Lowest Innings run(1st Inn) - Only First Innings is Valid.1st Inning Playing Team must be Played 20 Overs or If Team get all out means Only Considered.",
            "danger": false
          },
          {
            "text": "Lowest Innings run(both Inn) - Both Innings are Valid. 2nd Innings Playing Team must be Complete the Match or Getting All out Means Only Considered.DLS Result not Considered in this.",
            "danger": false
          },
          {
            "text": "Highest Total Runs in Single Match of IPL: Maximum Runs Scored by both Teams in Single Match.",
            "danger": false
          },
          {
            "text": "Highest Partnership Runs in IPL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "Highest Partnership Balls in IPL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "Tournament Topbatsman Runs in IPL : Highest Run Scored by any Individual Batsman in an Innings.Both Innings are Valid",
            "danger": false
          },
          {
            "text": "Largest Margin Win by Runs of IPL : Maximum Runs Margin Win by Any Team. Example : CSK 210 in 1st Inn and MI 150 in 2nd Inn Means CSK Win by 60 run Margin.",
            "danger": false
          },
          {
            "text": "Highest Run Scorer Runs of IPL (Orange Cap) : Maximum Runs Scored by an Individual Batsman in Full Tournament",
            "danger": false
          },
          {
            "text": "Highest Wicket Taker Wickets of IPL (Purple Cap) : Maximum Wickets Taken by a Bowler in Full Tournament",
            "danger": false
          },
          {
            "text": "How Many time 5 or More Wickets taken by Bowlers : Number of time 5 or More Wickets taken by Bowlers. In Case Same Bowler 2 time 5 or More Wickets taken means Result Counted as 2.",
            "danger": false
          },
          {
            "text": "Total 4's: Average 30 Fours will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total 6's: Average 18 Sixes will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total 30's: Average 3 Thirties will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total 50's: Average 2 Fifties will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total No balls:- Average 1 No ball will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Wickets - Average will 13 Wickets be given in Case Match abandoned or over Reduced",
            "danger": false
          },
          {
            "text": "Total Wides - Average 11 Wides will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Extras - Average 17 Extras will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Caught outs: Average 9 Caught out will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Bowled:- Average 2 Bowled out will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total LBW:- Average 1 LBW will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Run out:- Average 1 Run out will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Duckouts in IPL : Average 1 Duckout will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total 50+ Partnerships - Average 2 Fifty plus Partnerships will be Given in Case Match Abandoned or Over Reduced. 50 and 50 Above Partnerships All Counted in this.",
            "danger": false
          },
          {
            "text": "Total Highest Scoring Over Runs in IPL: Average 22 Runs will be Given in Case Match Abandoned or Over Reduced. Total of Every Match Highest Scoring Over Runs.",
            "danger": false
          },
          {
            "text": "Highest Match 1st Over Run of IPL (1st Inn) :Only First Innings is Valid.",
            "danger": false
          },
          {
            "text": "Highest 1st 6 over run(1st Inn): Only First Innings is Valid.Will not Consider if over Reduce before Completion 6 over.",
            "danger": false
          },
          {
            "text": "Highest 1st 10 over run(1st Inn) : Only First Innings is Valid.Will not Consider if over Reduce before Completion 10 over.",
            "danger": false
          },
          {
            "text": "Highest 4s,6s,30s,50s,50+ Pship,Duckouts,Single Digit Scorers, Double Digit Scorers,Wickets,Wides, Noballs,Extras,Caught Outs,Bowled,Lbw, Runouts and Stumpings in Individual Match: All Both Innings are Counted.",
            "danger": false
          },
          {
            "text": "Single Digit Scorers : Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
            "danger": false
          },
          {
            "text": "Highest Scoring Over Runs in IPL: Both Innings are Valid",
            "danger": false
          },
          {
            "text": "Most Balls Faced By a Batsman in an Inn of IPL : Maximum balls Faced by an Individual Batsman in the Single Match.",
            "danger": false
          },
          {
            "text": "Most Runs Given by a Bowler in an Inn of IPL : Maximum Runs Conceded by a Individual Bowler in an Innings.",
            "danger": false
          },
          {
            "text": "Most Wicket by a Bowler in an Inn of IPL : Maximum Wicket taken by a Individual Bowler in an Innings",
            "danger": false
          },
          {
            "text": "Most 4s Hitted by a Batsman of IPL: Maximum 4s Hitted by a Batsman in Full Tournament",
            "danger": false
          },
          {
            "text": "Most 6s Hitted by a Batsman of IPL: Maximum 6s Hitted by a Batsman in Full Tournament",
            "danger": false
          },
          {
            "text": "Most 50s Scored by a Batsman of IPL : Maximum Fifty Hitted by a Batsman in Full Tournament",
            "danger": false
          },
          {
            "text": "Most Catches taken by a Player of IPL : Maximum Caught Out taken by a Player in Full Tournament.Fielder's, Bowler's and WicketKeeper's Caught outs all Considered in this Event",
            "danger": false
          },
          {
            "text": "Most 4's by a Batsman in an Inn of IPL : Maximum 4s Hitted by an Individual Batsman in any Single Match",
            "danger": false
          },
          {
            "text": "Most 6's by a Batsman in an Inn of IPL : Maximum 6s Hitted by an Individual Batsman in any Single Match",
            "danger": false
          },
          {
            "text": "Most 4s,6s,30s,50s,50+ Pships,Wide,Noball,Extras,Caught Outs,LBWs,Runouts and Duckouts in an Innings Of the Match : Considered For Any Single Innings.All Both Innings Considered as Valid",
            "danger": false
          },
          {
            "text": "Most Catches by a Player in an Inning of IPL : Any Single Player taking Maximum Catches in Single Match.Fielder's, Bowler's and WicketKeeper's Caught outs all Considered in this Event",
            "danger": false
          },
          {
            "text": "Most Wicket Keeper Dismissal in an Inning of IPL : Maximum Dismissal by Single Wicket Keeper in an Innings. Wicketkeeper's Caught outs and Stumping Only Considered",
            "danger": false
          },
          {
            "text": "Super over will not be Included",
            "danger": true
          },
          {
            "text": "At any Situation if Result is given for any particular event based on the rates given for the same, then the particular Result will be Considered Valid, similarly if the tournament gets canceled due to any reason the previously given Result will be Considered Valid",
            "danger": true
          },
          {
            "text": "In Fastest fifty always the first 50 runs will be Considered, for Example of R Sharma scores 1st fifty in 17 balls and scores 100 in next 14 balls, Fastest 50 will be given based on the balls for the 1st fifty runs",
            "danger": true
          },
          {
            "text": "If the Match starts Over Reduced Game or 20 Over Game, after the balls are Reduced due to Rain interrupting means comparison Events like Highest 4s,6s, boundaries,30s,50s, Wickets,Wides,Extras,Caughtouts,Bowled,Lbw,Runout,Duckout,Single Digit Scorers, Double Digit Scorers and Most 4s,6s,boundaries,30s,50s, Caught outs,Bowled,Duckout, wicket Keeper Dismissals all are Considered for Result.",
            "danger": true
          },
          {
            "text": "Example : If a Match started as 20 Overs game after Rain Overs Reduced to 16 Overs Match, in that Match Maximum 6s Reached Means that Value Considered for Result",
            "danger": true
          },
          {
            "text": "ICC WOMEN'S T20 WORLD CUP FINAL SPECIAL 2026",
            "danger": true
          },
          {
            "text": "Final Special Considered for 2 Semi Finals and 1 Final Match",
            "danger": true
          },
          {
            "text": "Reserve Day will be Considered",
            "danger": false
          },
          {
            "text": "Total Fours in Finals : Average 33 Fours will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Wkts in Finals : Average 13 Wickets will be given in Case Match abandoned or over Reduced",
            "danger": false
          },
          {
            "text": "Total Wides in Finals : Average 9 Wides will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Extras in Finals : Average 17 Extras will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Caught Outs in Finals : Average 8 Caught out will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Bowled in Finals : Average 3 Bowled out will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total LBWs in Finals : Average 1 LBW will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Runouts in Finals : Average 1 Run out will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total 30s in Finals : Average 2 Thirties will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Fifties in Finals : Average 1 Fifty will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Duckouts in Finals : Average 1 Duckout will be Given in Case Match Abandoned or Over Reduced",
            "danger": false
          },
          {
            "text": "Total Single Digit Scorers in Finals : Average 6 Scorers will be Given in Case Match Abandoned or Over Reduced. Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
            "danger": false
          },
          {
            "text": "Total Double Digit Scorers in Finals : Average 9 Scorers will be Given in Case Match Abandoned or Over Reduced.",
            "danger": false
          },
          {
            "text": "Total Four Hitters in Finals : Average 11 Hitters will be Given in Case Match Abandoned or Over Reduced.",
            "danger": false
          },
          {
            "text": "Total Six Hitters in Finals : Average 3 Hitters will be Given in Case Match Abandoned or Over Reduced.",
            "danger": false
          },
          {
            "text": "Total Wicket Takers in Finals : Average 7 Wicket takers will be Given in Case Match Abandoned or Over Reduced.",
            "danger": false
          },
          {
            "text": "Total of Highest Scoring Over Runs in Finals : Average 17 Runs will be Given in Case Match Abandoned or Over Reduced. Total of Every Match Highest Scoring Over Runs.",
            "danger": false
          },
          {
            "text": "The Hundred Men's Special 2026",
            "danger": true
          },
          {
            "text": "If Hundred fixture of 34 matches gets reduced due to any reason, then all the special fancies will be voided (Match abandoned due to rain/bad light will not be considered in this)",
            "danger": true
          },
          {
            "text": "At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid, similarly if the tournament gets canceled due to any reason the previously given result will be considered valid",
            "danger": true
          },
          {
            "text": "Management decision will be final",
            "danger": true
          },
          {
            "text": "Highest innings run - Only First innings is valid",
            "danger": false
          },
          {
            "text": "Lowest innings run - Only First innings is valid. 1st Inning playing team must be facing 100 balls or If team get all out means considered.",
            "danger": false
          },
          {
            "text": "Highest Partnership Runs in Hundred: Both Innings are valid",
            "danger": false
          },
          {
            "text": "Highest Partnership Balls in Hundred: Both Innings are valid",
            "danger": false
          },
          {
            "text": "Highest Run Scorer : Total Runs Scored by An Individual Batsman in Full Tournament",
            "danger": false
          },
          {
            "text": "Highest Wicket Taker : Total Wickets Taken by a Bowler in Full Tournament",
            "danger": false
          },
          {
            "text": "Total 4's: Average 24 Fours will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total 6's: Average 11 Sixes will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Boundaries: Average 35 Boundaries will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total 30's: Average 2 Thirties will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total 50's: Average 1 Fifties will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Wickets - Average will 12 Wickets be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Wides - Average 9 Wides will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Extras - Average 17 Extras will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Caught outs: Average 8 Caught out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Bowled:- Average 2 Bowled out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total LBW:- Average 1 LBW will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Run out:- Average 1 Run out will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Duckouts in Hundred : Average 1 Duckout will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Total Single Digit Scorers in Hundred : Average 6 Single Digit Scorers will be given in case match abandoned or over reduced. Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
            "danger": false
          },
          {
            "text": "Total Double Digit Scorers in Hundred : Average 9 Double Digit Scorers will be given in case match abandoned or over reduced",
            "danger": false
          },
          {
            "text": "Highest 4s,6s,Boundaries,30s,50s,Wickets,Wides,Extras,Caught Outs,Bowled,Lbw, Runouts, Duckouts,Single Digit Scorers and Double Digit Scorers in individual match: All Both innings are Counted.",
            "danger": false
          },
          {
            "text": "Most 4s,6s,Boundaries,30s,50s,Caught Outs,Bowled,Duckouts and Wicketkeeper Dismissals in an Innings Of the Match : Considered For Any Innings.All Both Innings Considered as Valid",
            "danger": false
          },
          {
            "text": "Most 4s by a Batsman in the Match : Maximum 4s Hitted by an Individual Batsman in any Single Match",
            "danger": false
          },
          {
            "text": "Most 6s by a Batsman in the Match : Maximum 6s Hitted by an Individual Batsman in any Single Match",
            "danger": false
          },
          {
            "text": "Most Balls Faced By a Batsman of Hundred : Maximum balls Faced by an Individual Batsman in the Single Match.",
            "danger": false
          },
          {
            "text": "Most runs given by Bowler in an Inning of Hundred : Maximum Runs conceded by a individual Bowler in an Innings.",
            "danger": false
          },
          {
            "text": "Most wickets by Bowler in an inning : Maximum Wickets taken by a individual Bowler in an Innings",
            "danger": false
          },
          {
            "text": "\"If the match starts as a 100 ball game or Over Reduced Game, after the balls are reduced due to rain interrupting means comparison Events like Highest 4s,6s,boundaries,30s,50s,Wickets,Wides,Extras,Caughtouts,Bowled,Lbw,Runout,Duckout,Single Digit Scorers, Double Digit Scorers and Most 4s,6s,boundaries,30s,50s, Caught outs,Bowled,Duckout, wicket Keeper Dismissals all are considered for Result. Example : If a match started as 100 balls game after rain balls reduced to 80 balls match, in that match Maximum 6s reached means that Value considered for Result of Highest 6s in Individual Match.\"",
            "danger": true
          },
          {
            "text": "Super over (Super 5) will not be included.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          }
        ]
      },
      {
        "name": "khado",
        "rules": [
          {
            "text": "Only First inning valid for T20 and one day matches.",
            "danger": false
          },
          {
            "text": "Same will be work like Lambi. If match abandoned or over reduced, all bets will be deleted.",
            "danger": false
          },
          {
            "text": "You can choose your own value in this event.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Politics",
    "categories": [
      {
        "name": "fancy",
        "rules": [
          {
            "text": "1. This event is to decide the winner of various legislative assemblies of india.",
            "danger": false
          },
          {
            "text": "2. The final result declared by election commission of india for assembly elections of various states of india for a particular year will be valid in our exchange ,The customers are entirely responsible for their bets at all times.",
            "danger": false
          },
          {
            "text": "3. All bets will be voided if the election doesn't take place in given time by election commission or as per our exchange management decision.",
            "danger": false
          },
          {
            "text": "4. Company reserves the right to suspend/void any bets on this event at any time if we find the same not to be legitimate with the certainty of the outcome.",
            "danger": false
          },
          {
            "text": "5. Accidental issues during assembly elections will not be counted in our exchange If required Additional candidates may be added on request.",
            "danger": false
          },
          {
            "text": "6. Kindly be informed no candidates will be partially settled and will remain in the market until it is fully settled. This is to ensure that all customers can continue trading for the candidates that they have positions on, since each candidate is still a valid runner in this market.",
            "danger": false
          },
          {
            "text": "7. Please be informed that the transmissions described as \"live\" by few broadcasters may actually be delayed due to multiple scenarios.",
            "danger": false
          },
          {
            "text": "8. If any candidate withdraws for any reason, including death, all bets on the market will be valid and be settled as per the defined rules.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Golf",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Motor Sports",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      },
      {
        "name": "bookmaker",
        "rules": [
          {
            "text": "All race bets are settled on the official classification from the Federation Internationale de l’Automobile (FIA),the sport’s governing body, at the time of podium presentation.",
            "danger": false
          },
          {
            "text": "If a race is postponed ( Either before the start or via an interruption mid-race) but is concluded within 72 hours of the original scheduled start time , then all bets will stand.",
            "danger": false
          },
          {
            "text": "Our exchange management decision will be the final decision.",
            "danger": false
          },
          {
            "text": "Any query about the result should be contacted within 7 days of the specific event, the same will not be considered valid post 7 days from the event.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Baseball",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          }
        ]
      }
    ]
  },
  {
    "name": "Rugby Union",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Rugby League",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Darts",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "American Football",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": true
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          }
        ]
      }
    ]
  },
  {
    "name": "Snooker",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match Odds:- Predict which player will win the match. In the event of a match starting but not being completed the player progressing to the next round or being awarded the victory will be deemed the winner for settlement purposes. In the event of a match not starting at all, all bets are refunded.",
            "danger": false
          },
          {
            "text": "Frame Winner :- If the nominated frame is not played bets will be void. Similarly, if the nominated frame is awarded to a player without a shot being played, then all bets will be void.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Boxing",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Soccer",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Esports",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Greyhound Racing",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Kabaddi",
    "categories": [
      {
        "name": "fancy",
        "rules": [
          {
            "text": "1. In any circumstances management decision will be final related to all Fancy of kabaddi of our exchange.",
            "danger": false
          },
          {
            "text": "2. All fancy bets will be validated when match has been tied.",
            "danger": false
          },
          {
            "text": "3. Result of individual player of fancy will be validated only when player play that match.",
            "danger": false
          },
          {
            "text": "4. In any case wrong rate has been given in fancy that particular bets will be deleted.",
            "danger": false
          },
          {
            "text": "5. Final Result Of 40 Minutes Of Two Halves Will Be Valid In Our Exchange",
            "danger": false
          },
          {
            "text": "6. In case, company will find Ground bets, Group betting, Punching bets, Multiple entries with same IP or any fraud or unusual activities are detected then Company will be void winning bets and charge penalty of 2X (Two times) from winning amount.",
            "danger": false
          },
          {
            "text": "7. If any player will get injured during the match, then all the bets will be valid of that individual player",
            "danger": false
          }
        ]
      },
      {
        "name": "bookmaker",
        "rules": [
          {
            "text": "In case, company will find Ground bets, Group betting, Punching bets, Multiple entries with same IP or any fraud or unusual activities are detected then Company will be void winning bets and charge penalty of 2X (Two times) from winning amount.",
            "danger": false
          },
          {
            "text": "Final Result Of 40 Minutes Of Two Halves Will Be Valid In Our Exchange",
            "danger": false
          }
        ]
      },
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Boat Racing",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Esoccer",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Wrestling",
    "categories": [
      {
        "name": "bookmaker",
        "rules": [
          {
            "text": "Bookmaker (Virtual)",
            "danger": true
          },
          {
            "text": "1. For Virtual events this refers to the outcome of the simulated match as determined by the game and the platform system.",
            "danger": false
          },
          {
            "text": "2. We Consider Winning Method Pin, Submission and Ring out. (Normal One – One Match).",
            "danger": false
          },
          {
            "text": "3. We Consider Player Taking Points Method Pin, Submission and Ring out. (For Ironman only).",
            "danger": false
          },
          {
            "text": "4. In case technical error or any circumstances Bookmaker is suspended and does not resume result will be not given all bets will be deleted.",
            "danger": false
          },
          {
            "text": "5. If any case wrong rate has been given in that particular bets will be cancelled.",
            "danger": false
          },
          {
            "text": "6. The winner will be the wrestler with most points, if both wrestlers have equal number of points the match will be drawn. (For Ironman Only)",
            "danger": false
          }
        ]
      },
      {
        "name": "fancy",
        "rules": [
          {
            "text": "Normal (Virtual)",
            "danger": true
          },
          {
            "text": "All Fancy Advance events will be suspended either 3 minutes after the match starts or as soon as any player scores the first point — whichever happens first.",
            "danger": true
          },
          {
            "text": "1. All fancy bets will be validated when match has been tied.",
            "danger": false
          },
          {
            "text": "2. In case technical error or any circumstances Fancy is suspended and does not resume result will be not given all bets will be deleted.",
            "danger": false
          },
          {
            "text": "3. If any case wrong rate has been given in fancy that particular bets will be cancelled.",
            "danger": false
          },
          {
            "text": "4. We Consider Player Taking Points Method Pin, Submission and Ring out.",
            "danger": false
          },
          {
            "text": "5. Events are Player A Points, Player B Points and Total Match Points.",
            "danger": false
          },
          {
            "text": "6. Player A points Will be Result.",
            "danger": false
          },
          {
            "text": "7. Player B Points Will Be Result.",
            "danger": false
          },
          {
            "text": "8. Total Match Points are Consider Player A Points and Player B Points Will Be Result.",
            "danger": false
          }
        ]
      },
      {
        "name": "fancy1",
        "rules": [
          {
            "text": "All Fancy1 events will be suspended 10 minutes after the match begins.",
            "danger": true
          }
        ]
      }
    ]
  },
  {
    "name": "Beach Volleyball",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Table Tennis",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match odds :- Predict which player will win the match. In the event of any of the named players in a match changing before the match starts then all bets are void. In the event of a match starting but not being completed, all bets will be void.",
            "danger": false
          },
          {
            "text": "Set Winner :- The specified set must be completed for bets to stand, unless the specific market outcome is already determined.",
            "danger": false
          },
          {
            "text": "Under / Over Points :- For example, a game is abandoned at 9-7: bets on Over/Under 16.5 Game - Total Points are settled as winners/losers respectively, since any natural conclusion to the game would have yielded at least 18 points.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  },
  {
    "name": "Futsal",
    "categories": [
      {
        "name": "match",
        "rules": [
          {
            "text": "Match Odds:- Bets will be void if the match is not completed.",
            "danger": true
          },
          {
            "text": "Next Goal :- Predict which team will score the X-th goal.",
            "danger": false
          },
          {
            "text": "1st Half Winner:- Half bets will be settled at the end of the 1 st half. In the event of a 1 st half not being completed bets will be void.",
            "danger": false
          },
          {
            "text": "Highest Scoring Half:- Predict in which Event Part will be scored most.",
            "danger": false
          },
          {
            "text": "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.",
            "danger": true
          },
          {
            "text": "for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from \"live\" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.",
            "danger": false
          }
        ]
      }
    ]
  }
]

export default rulesData
